import axios from 'axios';
import { browserHistory } from 'react-router';
import { change } from 'redux-form';
import {
  REQUEST_PRODUCTS,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  REQUEST_PRODUCTS_BY_VENDOR,
  FETCH_PRODUCTS_BY_VENDOR_SUCCESS,
  FETCH_PRODUCTS_BY_VENDOR_FAILURE,
  SELECT_PRODUCT,
  RESET_CURRENT_PRODUCT,
  CLEAR_CURRENT_PRODUCT,
  SET_GROUP_CATEGORY,
  REQUEST_CREATING_PRODUCT,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  REQUEST_EDITING_PRODUCT,
  EDIT_PRODUCT_SUCCESS,
  EDIT_PRODUCT_FAILURE,
  REQUEST_EDITING_MULTI_PRODUCT,
  EDIT_MULTI_PRODUCT_SUCCESS,
  REQUEST_EDITING_MULTI_DEPS,
  EDIT_MULTI_DEPS_SUCCESS,
  EDIT_MULTI_PRODUCT_FAILURE,
  REQUEST_PRODUCT_DETAIL,
  FETCH_PRODUCT_DETAIL_SUCCESS,
  FETCH_PRODUCT_DETAIL_FAILURE,
  REQUEST_DISPLAY_CATEGORIES,
  FETCH_DISPLAY_CATEGORIES_SUCCESS,
  FETCH_DISPLAY_CATEGORIES_FAILURE,
  FETCH_DEP_CATEGORIES_SUCCESS,
  FETCH_DEP_CATEGORIES_SUCCESS_ALT,
  REQUEST_DEP_CATEGORIES,
  REQUEST_DEP_CATEGORIES_ALT,
  DELETE_PRODUCT_DEP_SUCCESS,
  REQUEST_DELETE_DEP,
  REQUEST_EDIT_DISPLAY_CATEGORIES,
  EDIT_DISPLAY_CATEGORIES_SUCCESS,
  EDIT_DISPLAY_CATEGORIES_FAILURE,
  REQUEST_GROUPS,
  REQUEST_DEPS,
  FETCH_DEPS_SUCCESS,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  SELECT_GROUP,
  SELECT_DEP,
  RESET_CURRENT_GROUP,
  REQUEST_CREATING_GROUP,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAILURE,
  REQUEST_EDITING_GROUP,
  EDIT_GROUP_SUCCESS,
  EDIT_GROUP_FAILURE,
  REQUEST_EDITING_MULTI_GROUPS,
  EDIT_MULTI_GROUPS_SUCCESS,
  EDIT_MULTI_GROUPS_FAILURE,
  REQUEST_CATEGORIES,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  REQUEST_GROUP_CATEGORIES,
  REQUEST_GROUP_CATEGORIES_ALT,
  FETCH_GROUP_CATEGORIES_SUCCESS_ALT,
  FETCH_GROUP_CATEGORIES_SUCCESS,
  FETCH_GROUP_CATEGORIES_FAILURE,
  SELECT_CATEGORY,
  SELECT_CATEGORY_B2B,
  RESET_CURRENT_CATEGORY,
  RESET_CURRENT_CATEGORY_B2B,
  REQUEST_CREATING_CATEGORY,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  REQUEST_EDITING_CATEGORY,
  EDIT_CATEGORY_SUCCESS,
  EDIT_CATEGORY_FAILURE,
  REQUEST_EDITING_MULTI_CATEGORIES,
  EDIT_MULTI_CATEGORIES_SUCCESS,
  EDIT_MULTI_CATEGORIES_FAILURE,

  REQUEST_CATEGORIES_2,
  FETCH_CATEGORIES_2_SUCCESS,
  FETCH_CATEGORIES_2_FAILURE,
  REQUEST_EDITING_MULTI_CATEGORIES_2,
  EDIT_MULTI_CATEGORIES_2_SUCCESS,
  EDIT_MULTI_CATEGORIES_2_FAILURE,
  REQUEST_DELETE_CATEGORY_2,
  DELETE_CATEGORY_2_SUCCESS,
  DELETE_CATEGORY_2_FAILURE,
  CLEAR_CATEGORY_2_STATUS,

  REQUEST_CATEGORIES_2_B2B,
  FETCH_CATEGORIES_2_SUCCESS_B2B,
  FETCH_CATEGORIES_2_FAILURE_B2B,
  REQUEST_EDITING_MULTI_CATEGORIES_2_B2B,
  EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B,
  EDIT_MULTI_CATEGORIES_2_FAILURE_B2B,
  REQUEST_DELETE_CATEGORY_2_B2B,
  DELETE_CATEGORY_2_SUCCESS_B2B,
  DELETE_CATEGORY_2_FAILURE_B2B,
  CLEAR_CATEGORY_2_STATUS_B2B,
  REQUEST_CATEGORY2_PRODUCTS_B2B,
  FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B,
  FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B,
  RESET_CATEGORY2_ID,

  REQUEST_PRICELEVELS,
  FETCH_PRICELEVELS_SUCCESS,
  FETCH_PRICELEVELS_FAILURE,
  REQUEST_EDITING_MULTI_PRICELEVELS,
  EDIT_MULTI_PRICELEVELS_SUCCESS,
  EDIT_MULTI_PRICELEVELS_FAILURE,
  REQUEST_TYPES,
  FETCH_TYPES_SUCCESS,
  FETCH_TYPES_FAILURE,
  REQUEST_PRODUCT_INFO,
  FETCH_PRODUCT_INFO_SUCCESS,
  FETCH_PRODUCT_INFO_FAILURE,
  REQUEST_SIMPLIFIED_PRODUCTS,
  FETCH_SIMPLIFIED_PRODUCTS_SUCCESS,
  FETCH_SIMPLIFIED_PRODUCTS_FAILURE,
  RESET_CATEGORY,
  RESET_GROUP_AND_CATEGORY,
  REQUEST_PRODUCT_BY_NUM,
  FETCH_PRODUCT_BY_NUM_SUCCESS,
  FETCH_PRODUCT_BY_NUM_FAILURE,
  REQUEST_DELETE_CATEGORY,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  REQUEST_DELETE_GROUP,
  DELETE_PRODUCT_GROUP_SUCCESS,
  DELETE_GROUP_FAILURE,
  CLEAR_CATEGORY_STATUS,
  CLEAR_GROUP_STATUS,
  REINITIALZIE_PRODUCT_FORM,
  REQUEST_SMALL_PRODUCT_INFO,
  FETCH_SMALL_PRODUCT_INFO_SUCCESS,
  FETCH_SMALL_PRODUCT_INFO_FAILURE,
  CLEAR_SMALL_PRODUCT,
  REQUEST_CRV_VALUES,
  FETCH_CRV_VALUES_SUCCESS,
  FETCH_CRV_VALUES_FAILURE,
  ATTACH_PRODUCT_IMAGE,
  ATTACH_PRODUCT_IMAGE_SUCCESS,
  ATTACH_PRODUCT_IMAGE_FAILURE,
  CLEAR_ATTACHED_PRODUCT_IMAGE,
  SET_CURRENT_PRODUCT,
  FETCH_RELATED_PRODUCTS,
  FETCH_RELATED_PRODUCTS_SUCCESS,
  FETCH_RELATED_PRODUCTS_FAILURE,
  FETCH_SUGGESTED_PROD_NUM,
  FETCH_SUGGESTED_PROD_NUM_SUCCESS,
  FETCH_SUGGESTED_PROD_NUM_FAILURE,
  FETCH_SUGGEST_DIGIT,
  FETCH_SUGGEST_DIGIT_SUCCESS,
  FETCH_SUGGEST_DIGIT_FAILURE,
  CLEAR_SUGGEST_DIGIT,
  FETCH_PACKAGE_TYPES,
  FETCH_PACKAGE_TYPES_SUCCESS,
  FETCH_PACKAGE_TYPES_FAILURE,
  EDIT_PACKAGE_TYPE,
  EDIT_PACKAGE_TYPE_SUCCESS,
  EDIT_PACKAGE_TYPE_FAILURE,
  CLEAR_PACKAGE_TYPE_EDITED,
  REQUEST_DELETE_PACKAGE_TYPE,
  DELETE_PACKAGE_TYPE_SUCCESS,
  DELETE_PACKAGE_TYPE_FAILURE,
  FETCH_MEASUREMENT_UNIT,
  FETCH_MEASUREMENT_UNIT_SUCCESS,
  FETCH_MEASUREMENT_UNIT_FAILURE,
  EDIT_MEASUREMENT_UNIT,
  EDIT_MEASUREMENT_UNIT_SUCCESS,
  EDIT_MEASUREMENT_UNIT_FAILURE,
  CLEAR_MEASUREMENT_UNIT_EDITED,
  REQUEST_DELETE_MEASUREMENT_UNIT,
  DELETE_MEASUREMENT_UNIT_SUCCESS,
  DELETE_MEASUREMENT_UNIT_FAILURE,
  FETCH_CONVERTABLE_PRODUCTS,
  FETCH_CONVERTABLE_PRODUCTS_SUCCESS,
  FETCH_CONVERTABLE_PRODUCTS_FAILURE,
  ATTACH_DOCUMENT,
  ATTACH_DOCUMENT_SUCCESS,
  ATTACH_DOCUMENT_FAILURE,
  FETCH_CATEGORY2_PRODUCTS_SUCCESS,
  FETCH_CATEGORY2_PRODUCTS_FAILURE,
  REQUEST_CATEGORY2_PRODUCTS,
  // cont / disc product
  REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT,
  CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS,
  CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE,
  DELETE_PRODUCT,

  // Default buyer
  REQUEST_DEFAULT_BUYERS,
  REQUEST_DEFAULT_BUYERS_SUCCESS,
  REQUEST_DEFAULT_BUYERS_FAILURE,

  REQUEST_UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCEESS,
  UPDATE_PRODUCT_FAILURE,

  SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS,
  SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE,
  REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,

  REQUEST_INITIALIZE_ESL,
  REQUEST_DELETE_ESL,
  REQUEST_FETCH_ESL_TEMPLATE,
  REQUEST_SAVE_ESL,
  REQUEST_FETCH_ESL,
  FETCH_PRODUCT_PARTS_LIST,
  FETCH_PRODUCT_PARTS_LIST_SUCCESS,
  FETCH_PRODUCT_PARTS_LIST_FAILURE,
} from './type';
import {
  BASE_USER_URL,
  PRODUCTS_URL,
  GROUPS_URL,
  DEP_URL,
  CATEGORIES_URL,
  CATEGORIES_2_URL,
  CATEGORIES_2_B2B_URL,
  TYPES_URL,
  PRICELEVELS_URL,
  PURCHASE_URL,
  PURCHASE_URL_2,
  PRODUCTS_SIMPLIFIED_URL,
  INVENTORY_CONVERTS_URL,
  UPLOAD_URL,
  DISPLAY_CATEGORIES_URL,
  ESL_INITIALIZE,
  ESL_DELETE,
  ESL_GET_TEMPLATE,
  ESL_SAVE,
  SALES_ORDER_PRODUCT_BY_ID_URL,
  GENERAL_LEDGER_URL, MFG_BOM_PRODUCTS_URL,
  PRODUCTS_IMPORT_URL,
} from './url';

import {
  ROOT_URL, ROOT_API_URL, isHMM, isGGI, isGFD, isOLG, isVAK, isAGD, isSV, isSH,
  isTQ
} from './root_url'

const isSUNNY = ROOT_API_URL === 'https://sunny-scm.truckxi.com/api/';
const isAFM =
  ROOT_API_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afm-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://afmstage-scm.truckxi.com/api/" ||
  ROOT_URL === "https://afmstage-scm.truckxi.com/api/";

import { DEFAULT_ERROR } from '../components/Common/constants';

const isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

const mapTQProdDetails = (productDetails) => {
  const result = {
    ...productDetails,
    ConvertTargetProducts: productDetails.ConvertTargetProducts && productDetails.ConvertTargetProducts.join(',')
  }
  return result;
}

const mapGFDProdDetails = (p) => {
  return {
    ...p,
    Warehouse: p.Warehouse && p.Warehouse.join(','),
  }
}

export function requestProducts() {
  return {
    type: REQUEST_PRODUCTS,
  };
}
export function fetchProductsSuccess(products) {
  return {
    type: FETCH_PRODUCTS_SUCCESS,
    payload: products,
  };
}
export function fetchProductsFailure(error) {
  return {
    type: FETCH_PRODUCTS_FAILURE,
    payload: error,
  };
}
export function fetchProducts(filters, buyer, page, limit, isDiscontinued) {
  let url = PRODUCTS_URL;
  if (isSV && filters) {
    url = `${PRODUCTS_URL}?searchType=${filters.searchType}&lowerRange=${filters.lowerRange}&upperRange=${filters.upperRange}`
  }
  if(isVAK){
    if (page !== null && page !== undefined) {
      url+= `?page=${page + 1}`
    } else{
      url+= `?page=1`
    }
    if (limit !== null && limit !== undefined) {
      url+=`&limit=${limit}`
    } else {
      url+= `&limit=30`;
    }
  }
  
  if (isSH && (isDiscontinued === 0 || isDiscontinued == 1)) {
    url+= `?IsDiscontinued=${isDiscontinued}`;
  }
  
  return (dispatch) => {
    dispatch(requestProducts());
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductsFailure(err));
        }
      });
  };
}

export function requestProductsByGroup() {
  return {
    type: REQUEST_PRODUCTS,
  };
}
export function fetchProductsByGroupSuccess(products) {
  return {
    type: FETCH_PRODUCTS_SUCCESS,
    payload: products,
  };
}
export function fetchProductsByGroupFailure(error) {
  return {
    type: FETCH_PRODUCTS_FAILURE,
    payload: error,
  };
}
export function fetchProductsByGroup(id, filters, dep, buyer, page, limit, isDiscontinued) {
  if (id === -1 && (!buyer || buyer === "All")) {
    if(isVAK){
      return (dispatch) => { dispatch(fetchProducts(filters, buyer, page, limit)); };
    } else if (isSH) {
      return (dispatch) => { dispatch(fetchProducts(filters, buyer, null, null, isDiscontinued)); };
    } else{
      return (dispatch) => { dispatch(fetchProducts(filters, buyer)); };
    }
  }
  let url = `${PRODUCTS_URL}search/?ProductGroup_id=${id}`

  if (dep) {
    url = `${PRODUCTS_URL}search/?ProductDepartment_id=${id}`
  }

  if (isGFD && id === -1 && buyer) {
    url = `${PRODUCTS_URL}search/?ProductDepartment_id__BuyerId=${buyer}`;
  }

  if (isSV && filters) {
    url = `${PRODUCTS_URL}search/?ProductGroup_id=${id}&searchType=${filters.searchType}&lowerRange=${filters.lowerRange}&upperRange=${filters.upperRange}`
  }
  
  if(isVAK){
    const sortKeyMap = {
      'ProductNum': 'productNum',
      'GeneralNum': 'generalNum',
      'RefNum': 'refNum',
      'Name': 'name',
      'Description': 'description',
    }
    if(filters &&  Object.keys(filters).length){
      for (var key in filters) {
        url += `&${sortKeyMap[key]}=${filters[key].filterTerm}`
      }
    }
    if (page !== null && page !== undefined) {
      url+= `&page=${page + 1}`
    }else{
      url+= `&page=1`
    }
    if (limit !== null && limit !== undefined) {
      url+=`&limit=${limit}`
    } else {
      url+= `&limit=30`;
    }
  }
  if (isSH && (isDiscontinued === 0 || isDiscontinued == 1)) {
    url+= `&IsDiscontinued=${isDiscontinued}`;
  }
  
  return (dispatch) => {
    dispatch(requestProductsByGroup());
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductsByGroupSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductsByGroupFailure(err));
        }
      });
  };
}

export function requestProductsByCategory() {
  return {
    type: REQUEST_PRODUCTS,
  };
}
export function fetchProductsByCategorySuccess(products) {
  return {
    type: FETCH_PRODUCTS_SUCCESS,
    payload: products,
  };
}
export function fetchProductsByCategoryFailure(error) {
  return {
    type: FETCH_PRODUCTS_FAILURE,
    payload: error,
  };
}
export function fetchProductsByCategory(id, handleSuccess = () => {}, handleFailure = () => {}, requestedFromProductFormPage, page = null, limit = null, filters = null, isDiscontinued) {
  if (id === -1) {
    return (dispatch) => { dispatch(fetchProducts()); };
  }
  return (dispatch) => {
    dispatch(requestProductsByCategory());
    let query = (isSUNNY && requestedFromProductFormPage) ? '&related=true' : '';
    let pageParams = ''
    if(isVAK){
      if(filters &&  Object.keys(filters).length){
        for (var key in filters) {
          if (key === 'ProductNum') {
            pageParams += `&productNum=${filters['ProductNum'].filterTerm}`
          }
          if (key === 'GeneralNum') {
            pageParams += `&generalNum=${filters['GeneralNum'].filterTerm}`
          }
          if (key === 'RefNum') {
            pageParams += `&refNum=${filters['RefNum'].filterTerm}`
          }
          if (key === 'Name') {
            pageParams += `&name=${filters['Name'].filterTerm}`
          }
          if (key === 'Description') {
            pageParams += `&description=${filters['Description'].filterTerm}`
          }
        }
      }
    }
    if (page !== null) {
      pageParams += `&page=${page + 1}`
    }
    if (limit !== null) {
      pageParams += `&limit=${limit}`
    }
    
    if (isSH && (isDiscontinued === 0 || isDiscontinued == 1)) {
      pageParams+= `&IsDiscontinued=${isDiscontinued}`;
    }
    return axios.get(
      (isSV && requestedFromProductFormPage) ? `${PRODUCTS_URL}search/` : `${PRODUCTS_URL}search/?ProductCategory1_id=${id}${query}${pageParams}`,
      // `${PRODUCTS_URL}search/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        handleSuccess(response);
        dispatch(fetchProductsByCategorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          handleFailure(err);
          dispatch(fetchProductsByCategoryFailure(err));
        }
      });
  };
}
export function fetchProductsByParams(params, handleSuccess = () => {}, handleFailure = () => {}) {
  return dispatch => {
    return axios.get(MFG_BOM_PRODUCTS_URL, {
      params,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err);
      }
    });
  }
}

export function fetchProductsByCategorySunset(id, filters) {
  if (id === -1) {
    return (dispatch) => { dispatch(fetchProducts(filters)); };
  }
  let url = `${PRODUCTS_URL}search/?ProductCategory1_id=${id}`;
  if (isSV && filters) {
    url = `${PRODUCTS_URL}search/?ProductCategory1_id=${id}&searchType=${filters.searchType}&lowerRange=${filters.lowerRange}&upperRange=${filters.upperRange}`
  }
  return (dispatch) => {
    dispatch(requestProductsByCategory());
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductsByCategorySuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductsByCategoryFailure(err));
        }
      });
  };
}

export function requestProductsByCategory2(id) {
  return {
    type: REQUEST_CATEGORY2_PRODUCTS,
    payload: id,
  };
}

export function fetchProductsByCategory2Success(products) {
  return {
    type: FETCH_CATEGORY2_PRODUCTS_SUCCESS,
    payload: products,
  };
}
export function fetchProductsByCategory2Failure(error) {
  return {
    type: FETCH_CATEGORY2_PRODUCTS_FAILURE,
    payload: error,
  };
}

export function fetchCategory2Products(id, warehouse) {
  if (id === -1) {
    return (dispatch) => { dispatch(fetchProducts()); };
  }
  return (dispatch) => {
    dispatch(requestProductsByCategory2(id));
    return axios.get(
      `${PRODUCTS_URL}category2/${id}/product?${isAFM && 'BelongWarehouse='}${isAFM && warehouse}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductsByCategory2Success(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductsByCategory2Failure(err));
        }
      });
  };
}

export function requestProductsByCategory2B2B(id) {
  return {
    type: REQUEST_CATEGORY2_PRODUCTS_B2B,
    payload: id,
  };
}

export function resetCategory2Id() {
  return {
    type: RESET_CATEGORY2_ID,
  }
}

export function fetchProductsByCategory2SuccessB2B(products) {
  return {
    type: FETCH_CATEGORY2_PRODUCTS_SUCCESS_B2B,
    payload: products,
  };
}
export function fetchProductsByCategory2FailureB2B(error) {
  return {
    type: FETCH_CATEGORY2_PRODUCTS_FAILURE_B2B,
    payload: error,
  };
}

export function fetchCategory2ProductsB2B(id) {
  if (id === -1) {
    return (dispatch) => { dispatch(fetchProducts()); };
  }
  return (dispatch) => {
    dispatch(requestProductsByCategory2B2B(id));
    return axios.get(
      `${PRODUCTS_URL}category2_b2b/${id}/product`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductsByCategory2SuccessB2B(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductsByCategory2FailureB2B(err));
        }
      });
  };
}

export function requestProductsByVendor() {
  return {
    type: REQUEST_PRODUCTS_BY_VENDOR,
  };
}
export function fetchProductsByVendorSuccess(products) {
  return {
    type: FETCH_PRODUCTS_BY_VENDOR_SUCCESS,
    payload: products,
  };
}
export function fetchProductsByVendorFailure(error) {
  return {
    type: FETCH_PRODUCTS_BY_VENDOR_FAILURE,
    payload: error,
  };
}
export function fetchProductsByVendor(Vendor_id) {
  return (dispatch) => {
    dispatch(requestProductsByVendor());
    return axios.get(
      `${PRODUCTS_URL}vendor/${Vendor_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductsByVendorSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductsByVendorFailure(err));
        }
      });
  };
}

export function requestProductInfo() {
  return {
    type: REQUEST_PRODUCT_INFO,
  };
}
export function fetchProductInfoSuccess(productInfo) {
  return {
    type: FETCH_PRODUCT_INFO_SUCCESS,
    payload: productInfo,
  };
}
export function fetchProductInfoFailure(error) {
  return {
    type: FETCH_PRODUCT_INFO_FAILURE,
    payload: error,
  };
}
export function fetchProductInfo(Product_id) {
  return (dispatch) => {
    dispatch(requestProductInfo());
    return axios.get(
      `${PURCHASE_URL}line/info/${Product_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductInfoSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductInfoFailure(err));
        }
      });
  };
}

export function fetchProductInfo2(Product_id, company_id, warehouse_id, customer_id) {
  return (dispatch) => {
    dispatch(requestProductInfo());
    return axios.get(
      `${SALES_ORDER_PRODUCT_BY_ID_URL}${customer_id}/?Product_id=${Product_id}&Company_id=${company_id}&warehouse_id=${warehouse_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductInfoSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductInfoFailure(err));
        }
      });
  };
}

export function selectProduct(product) {
  return {
    type: SELECT_PRODUCT,
    payload: product,
  };
}
export function resetCurrentProduct() {
  return {
    type: RESET_CURRENT_PRODUCT,
  };
}

export function clearCurrentProduct() {
  return {
    type: CLEAR_CURRENT_PRODUCT,
  };
}
export function setGroupCategory(currentGroupCategory) {
  return {
    type: SET_GROUP_CATEGORY,
    payload: currentGroupCategory,
  };
}

export function reinitialize(data) {
  return {
    type: REINITIALZIE_PRODUCT_FORM,
    payload: data,
  };
}

// Actions to deal with the promise of posting function.
export function createProduct({
  LevelType,
  popularity,
  IsFoodStamp,
  RefPriceMode,
  ESLCode,
  TemplateName,
  AutoPO,
  default_po_quantity,
  LimitQuantityPerOrder,
  MultipleQuantityPerOrder,
  MixedProductBaseUnit,
  MixedProduct,
  BinRangeList,
  ProductNum,
  RefNum,
  Name,
  Description,
  Description2,
  Description3,
  ConvertType,
  ConvertNum,
  Notes,
  ProdCreateDate,
  MinOrderQty,
  ClassNo,
  CatalogPage,
  BaseCost,
  CustomDutyPercent,
  HtmsNum,
  // CaseCost,
  PromoTier1Qty,
  PromoTier2Qty,
  Units_Case,
  Units_InnerBox,
  CRV,
  CRV_id,
  FOBCost,
  PackageSize,
  Width,
  Length,
  Height,
  HMartCode,
  MeasureUnit,
  NetWeight,
  CaseWt,
  BoxWt,
  ShippingWeight,
  MaxWeightRange,
  MinWeightRange,
  MaxStockRange,
  MinStockRange,
  ShiftLife,
  BufferTime,
  ProductBarcode,
  Purchaser_User_id,
  IsStopPurchase,
  Sales_User_id,
  InternalBarcode,
  IsDiscontinued,
  IsB2B,
  IsB2C,
  IsTaxable,
  msrp,
  IsAllTaxable,
  IsNonFood,
  IsOverSaleable,
  IsPromotion,
  IsStopSale,
  GeneralNum,
  IsWholesaleOnly,
  IsMobile,
  IsSoldNationwide,
  IsSyncNuOrder,
  IsSyncShopify,
  IsRetailPack,
  IsCombo,
  IsNewArrival,
  IsGreatDeal,
  PurchaseConvertUnit,
  IsProposition65,
  IsSyncToScales,
  IsSyncToESL,
  IsWebDisplay,
  IsAFGChioce,
  IsAlcohol,
  NetCost,
  ProductCost,
  LowestSalePrice,
  RefPrice,
  Related_Product_id,
  ProductDepartment_id,
  ProductGroup_id,
  ProductCategory1_id,
  ProductCategory2_id,
  Default_Warehouse_id,
  Default_WarehouseZone_id,
  Default_WarehouseFromBin_id,
  Default_WarehouseToBin_id,
  PackageType,
  ProductType,
  Tare,
  DateFlag,
  Vendors,
  SmallProdNum,
  SmallNetWeight,
  SmallFixedWeight,
  SmallCatchWeight,
  UnitPerPallet,
  VendorProdNo,
  IsRelated,
  IsLarge,
  InStockPrice,
  RoundPriceLevels,
  PriceType,
  PackageSize_1,
  PackageType_2,
  PackageSize_2,
  MeasureUnit_2,
  CalcoDispatchCase,
  CalcoDispatchBag,
  DimensionUnit,
  DimensionHeight,
  DimensionLength,
  DimensionWidth,
  BoxDimensionHeight,
  BoxDimensionLength,
  BoxDimensionWidth,
  CartonWidth,
  CartonHeight,
  CartonLength,
  CartonWeight,
  CaseHeight,
  CaseLength,
  CaseWidth,
  PalletHeight,
  PalletLength,
  PalletWidth,
  UnitCBF,
  UnitCBM,
  CaseCBF,
  CaseCBM,
  PalletCBF,
  PalletCBM,
  CasePerPallet,
  Volume,
  ViewableLanguages,
  ShippingFeeUnitPrice,
  TaxAmount,
  Temperature,
  MiscUnitPrice,
  Zone,
  Bin,
  Level,
  Zone2,
  Bin2,
  Level2,
  Zone3,
  Bin3,
  Level3,
  Brand,
  SubjectCategory,
  TopFlag,
  TJXStyleNum,
  UPC,
  GTIN,
  Color,
  Size,
  English_Details_Brand,
  Chinese_Details_Brand,
  English_Brand_Origin,
  Chinese_Brand_Origin,
  English_Details_NetContent,
  Chinese_Details_NetContent,
  English_Details_Made_In,
  Chinese_Details_Made_In,
  English_Details_Organic,
  Chinese_Details_Organic,
  English_Details_Contains_Sugar,
  Chinese_Details_Contains_Sugar,
  English_Details_Flavor,
  Chinese_Details_Flavor,
  English_Details_Ingredients,
  Chinese_Details_Ingredients,
  PackageSize_3,
  MeasureUnit_3,
  PalletSize,
  MadeIn,
  FW,
  CustomerStr,
  Channel,
  ActualNW,
  InventoryIsMobile,
  ItemMeasurement,
  CategoryNum,
  SyncInventory,
  GLaccount,
  // isSH
  ItemName,
  ColorCode,
  QBItemNum,
  RootDescription,
  PackingSizeCode,
  RootItemName,
  RootItemNum,
  OldPrintNum,
  ShortColorCode,
  BackColor,
  DesignPrintNum,
  ShortName,
  BoxPacking,
  AmazonItemNum,
  AmazonBoxPacking,
  AmazonSKU,
  AmazonPrice,
  RelocateTargetProduct,
  FrontPOColor,
  BackPOColor,

  // angel dear
  Type,
  ShortDescription,
  Gender,
  NRF_Color_Code,
  NRF_Size_Code,
  US_HTS_Codes,
  CartonVolume,
  CartonInnerQuantity,
  CartonQuantity,
  ProductFamilySKU,
  ProductFamilyName,
  ProductFamilyOption1Name,
  ProductFamilyOption1Value,
  ProductFamilyOption2Name,
  ProductFamilyOption2Value,
  ProductFamilyOption3Name,
  ProductFamilyOption3Value,
  ConvertTargetProducts,
  XFactor,
  Warehouse,
  IsDepartment,
}, {
  priceLv1,
  priceLv2,
  priceLv3,
  priceLv4,
  priceLv5,
  p1Percentage,
  p2Percentage,
  p3Percentage,
  p4Percentage,
  p5Percentage,
  ProductSKU,
  meta_info,
  selectedCompany,
  selectedWarehouse,
  selectedMarketing,
}) {
  
  if (MadeIn) MadeIn = MadeIn.value || MadeIn;
  if (FW) FW = FW.value || FW;
  if (CustomerStr) CustomerStr = CustomerStr.value || CustomerStr;

  if (GTIN) GTIN = GTIN.value || GTIN;
  if (Channel) Channel = Channel.value || Channel;

  let ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost);
  let CustomDutyCost = (Number(CustomDutyPercent ? CustomDutyPercent : 0)/100) * Number(BaseCost);
  if (isSV) {
    ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost) + CustomDutyCost;
  }
  if (isAGD) {
    CartonVolume = Number(CartonWidth) * Number(CartonHeight) * Number(CartonLength);
  }
  const newVendors = [];
  if (Vendors) {
    Vendors.map((vendor) => {
      if (vendor.Vendor_id) {
        vendor.Vendor_id = vendor.Vendor_id.value || vendor.Vendor_id;
      }
      if (vendor.Source) {
        vendor.Source = vendor.Source.value || vendor.Source
      }
      newVendors.push(vendor);
    });
  }
  if (Related_Product_id) Related_Product_id = Related_Product_id.value || Related_Product_id;
  if (ProductGroup_id) ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
  if (ProductDepartment_id) ProductDepartment_id = ProductDepartment_id.value || ProductDepartment_id;
  if (ProductCategory1_id) ProductCategory1_id = ProductCategory1_id.value || ProductCategory1_id;
  if (ProductCategory2_id) ProductCategory2_id = ProductCategory2_id.value || ProductCategory2_id;
  if (PackageType) PackageType = PackageType.value || PackageType;
  if (ProductType) ProductType = ProductType.value || ProductType;
  if (DateFlag) DateFlag = DateFlag.value || DateFlag;
  if (Default_Warehouse_id) Default_Warehouse_id = Default_Warehouse_id.value || Default_Warehouse_id;
  if (Default_WarehouseZone_id) Default_WarehouseZone_id = Default_WarehouseZone_id.value || Default_WarehouseZone_id;
  if (popularity) popularity = popularity.value || popularity;
  if (!IsDiscontinued) IsDiscontinued = 'false';
  if (!IsTaxable) IsTaxable = 'false';
  if (!IsAllTaxable) IsAllTaxable = 'false';
  if (!IsNonFood) IsNonFood = 'false';
  if (!IsOverSaleable) IsOverSaleable = 'false';
  if (!IsPromotion) IsPromotion = 'false';
  if (!IsWholesaleOnly) IsWholesaleOnly = 'false';
  if (PackageType_2) PackageType_2 = PackageType_2.value || PackageType_2;
  if (MeasureUnit_2) MeasureUnit_2 = MeasureUnit_2.value || MeasureUnit_2;
  if (MeasureUnit) { MeasureUnit = MeasureUnit.value || MeasureUnit; }
  if (MeasureUnit) { MeasureUnit = MeasureUnit.value || MeasureUnit; }
  if (TemplateName) TemplateName = TemplateName.value || TemplateName;
  if (GLaccount) GLaccount = GLaccount.value || GLaccount;
  if (RelocateTargetProduct) RelocateTargetProduct = RelocateTargetProduct.value || RelocateTargetProduct;
  const mixedProduct = [];
  if (MixedProduct) {
    for (var i = 0; i < MixedProduct.length; i++) {
      let temp = {};
      if (MixedProductBaseUnit.value) {
        temp.Unit = MixedProductBaseUnit.value;
      } else {
        temp.Unit = MixedProductBaseUnit;
      }
      if(MixedProduct[i].MixedUnit.value) {
        temp.MixedUnit = MixedProduct[i].MixedUnit.value;
      } else {
        temp.MixedUnit = MixedProduct[i].MixedUnit;
      }
      temp.ProductName = MixedProduct[i].ProductName;
      temp.ProductNum = MixedProduct[i].ProductNum;
      temp.ProductSKU = MixedProduct[i].ProductSKU;
      temp.Quantity = MixedProduct[i].Quantity;
      mixedProduct[i] = temp;
    }
  }
  if ( !isNumeric(LimitQuantityPerOrder) ) {
    if ( LimitQuantityPerOrder === null || LimitQuantityPerOrder === "" || !LimitQuantityPerOrder ) {
      LimitQuantityPerOrder = 0;
    } else {
      alert("Limited Qty/Order must be a number!");
      return (dispatch) => {
        dispatch({ type: CREATE_PRODUCT_FAILURE });
      }
    }
  }
  if (LimitQuantityPerOrder < 0) {
    LimitQuantityPerOrder = 0;
  }

  if ( !isNumeric(MultipleQuantityPerOrder) ) {
    if ( MultipleQuantityPerOrder === null || MultipleQuantityPerOrder === "" || !MultipleQuantityPerOrder ) {
      MultipleQuantityPerOrder = 0;
    } else {
      alert("Multiple Qty/Order must be a number!");
      return (dispatch) => {
        dispatch({ type: CREATE_PRODUCT_FAILURE });
      }
    }
  }
  if (MultipleQuantityPerOrder < 0) {
    MultipleQuantityPerOrder = 0;
  }
  let binRangeList = [];
  if (BinRangeList) {
    binRangeList = BinRangeList.slice();
    BinRangeList.map((bin, index) => {
      if ((typeof bin.DefaultBin === 'object') && bin.DefaultBin.value) {
        binRangeList[index].DefaultBin = bin.DefaultBin.value;
      } else {
        binRangeList[index].DefaultBin = bin.DefaultBin;
      }
      if ((typeof bin.Default_Level === 'object') && bin.Default_Level.value) {
        binRangeList[index].Default_Level = bin.Default_Level.value;
      } else {
        binRangeList[index].Default_Level = bin.Default_Level;
      }
    });
  }
  if (DimensionUnit && DimensionUnit.value) {
    DimensionUnit = DimensionUnit.value;
  }
  if (RefPriceMode && RefPriceMode.value) {
    RefPriceMode = RefPriceMode.value;
  }
  if (RefPriceMode === 'avg_cost') {
    RefPrice = InStockPrice;
  }
  if (RefPriceMode === 'prod_cost') {
    RefPrice = ProductCost;
  }
  let data = {
    LevelType,
    popularity,
    IsFoodStamp,
    RefPriceMode,
    ESLCode,
    TemplateName,
    IsSyncToESL,
    AutoPO,
    default_po_quantity,
    meta_title: meta_info.meta_title,
    meta_keywords: meta_info.meta_keywords,
    meta_description: meta_info.meta_description,
    LimitQuantityPerOrder,
    MultipleQuantityPerOrder,
    MixedProduct: mixedProduct,
    BinRangeList: binRangeList,
    ProductNum,
    RefNum,
    Name,
    Description,
    Description2,
    Description3,
    ConvertType,
    ConvertNum,
    Notes,
    MinOrderQty,
    ClassNo,
    CatalogPage,
    BaseCost,
    CustomDutyPercent,
    HtmsNum,
    // CaseCost,
    PromoTier1Qty,
    PromoTier2Qty,
    Units_Case,
    Units_InnerBox,
    ProdCreateDate,
    CRV,
    CRV_id: (CRV_id && CRV_id.value) || CRV_id,
    Purchaser_User_id: (Purchaser_User_id && Purchaser_User_id.value) || Purchaser_User_id,
    IsStopPurchase,
    Sales_User_id: (Sales_User_id && Sales_User_id.value) || Sales_User_id,
    PackageSize,
    Width,
    Length,
    Height,
    HMartCode,
    MeasureUnit,
    NetWeight,
    CaseWt,
    BoxWt,
    ShippingWeight,
    MaxWeightRange,
    MinWeightRange,
    MaxStockRange,
    MinStockRange,
    ShiftLife,
    BufferTime,
    ProductBarcode,
    InternalBarcode,
    IsDiscontinued,
    IsB2B,
    IsB2C,
    IsTaxable,
    msrp,
    IsAllTaxable,
    IsNonFood,
    IsOverSaleable,
    IsPromotion,
    IsStopSale,
    GeneralNum,
    IsWholesaleOnly,
    IsMobile,
    IsSoldNationwide,
    IsSyncNuOrder,
    IsSyncShopify,
    IsRetailPack,
    IsCombo,
    IsNewArrival,
    IsGreatDeal,
    PurchaseConvertUnit,
    IsProposition65,
    IsSyncToScales,
    IsAFGChioce,
    IsAlcohol,
    NetCost,
    ProductCost,
    LowestSalePrice,
    RefPrice,
    PriceLv1: priceLv1,
    PriceLv2: priceLv2,
    PriceLv3: priceLv3,
    PriceLv4: priceLv4,
    PriceLv5: priceLv5,
    PromoPrice1: priceLv1,
    PromoPrice2: priceLv2,
    PromoPrice3: priceLv3,
    P1Percentage: p1Percentage,
    P2Percentage: p2Percentage,
    P3Percentage: p3Percentage,
    P4Percentage: p4Percentage,
    P5Percentage: p5Percentage,
    Related_Product_id,
    ProductGroup_id,
    ProductDepartment_id,
    ProductCategory1_id,
    ProductCategory2_id,
    Default_Warehouse_id,
    Default_WarehouseZone_id,
    Default_WarehouseToBin_id,
    Default_WarehouseFromBin_id,
    PackageType,
    ProductType,
    Tare,
    DateFlag,
    UnitPerPallet,
    Vendors: newVendors,
    SmallProdNum,
    SmallNetWeight,
    SmallFixedWeight,
    SmallCatchWeight,
    VendorProdNo,
    IsRelated,
    IsLarge,
    InStockPrice,
    RoundPriceLevels,
    PriceType,
    PackageSize_1,
    PackageType_2,
    PackageSize_2,
    MeasureUnit_2,
    CalcoDispatchCase,
    CalcoDispatchBag,
    DimensionUnit,
    DimensionHeight,
    DimensionLength,
    DimensionWidth,
    CartonWidth,
    CartonHeight,
    CartonLength,
    CartonWeight,
    CaseHeight,
    CaseLength,
    CaseWidth,
    PalletHeight,
    PalletLength,
    PalletWidth,
    UnitCBF,
    UnitCBM,
    CaseCBF,
    CaseCBM,
    PalletCBF,
    PalletCBM,
    CasePerPallet,
    Volume,
    ViewableLanguages,
    ProductSKU,
    ShippingFeeUnitPrice,
    TaxAmount,
    Temperature,
    MiscUnitPrice,
    ArrivalPrice,
    CustomDutyCost,
    Zone,
    Bin,
    Level,
    Zone2,
    Bin2,
    Level2,
    Zone3,
    Bin3,
    Level3,
    Brand,
    SubjectCategory,
    TopFlag,
    TJXStyleNum,
    UPC,
    GTIN,
    Color,
    Size,
    English_Details_Brand,
    Chinese_Details_Brand,
    English_Brand_Origin,
    Chinese_Brand_Origin,
    English_Details_NetContent,
    Chinese_Details_NetContent,
    English_Details_Made_In,
    Chinese_Details_Made_In,
    English_Details_Organic,
    Chinese_Details_Organic,
    English_Details_Contains_Sugar,
    Chinese_Details_Contains_Sugar,
    English_Details_Flavor,
    Chinese_Details_Flavor,
    English_Details_Ingredients,
    Chinese_Details_Ingredients,
    PackageSize_3: PackageSize_3 || '',
    MeasureUnit_3: MeasureUnit_3 ? (MeasureUnit_3.value || MeasureUnit_3) : '',
    PalletSize,
    MadeIn,
    FW,
    CustomerStr,
    Channel,
    ActualNW,
    InventoryIsMobile,
    ItemMeasurement,
    CategoryNum,
    SyncInventory,
    GLaccount,
    // isSH
    ItemName,
    ColorCode,
    QBItemNum,
    RootDescription,
    PackingSizeCode,
    RootItemName,
    RootItemNum,
    OldPrintNum,
    ShortColorCode,
    BackColor,
    DesignPrintNum,
    ShortName,
    BoxPacking,
    AmazonItemNum,
    AmazonBoxPacking,
    AmazonSKU,
    AmazonPrice,
    RelocateTargetProduct,
    FrontPOColor,
    BackPOColor,
    
    // angel dear
    Type,
    ShortDescription,
    Gender,
    NRF_Color_Code,
    NRF_Size_Code,
    US_HTS_Codes,
    CartonVolume,
    CartonInnerQuantity,
    CartonQuantity,
    ProductFamilySKU,
    ProductFamilyName,
    ProductFamilyOption1Name,
    ProductFamilyOption1Value,
    ProductFamilyOption2Name,
    ProductFamilyOption2Value,
    ProductFamilyOption3Name,
    ProductFamilyOption3Value
  }
  if(isTQ) {
    let ConvertTargetProductsArray = [];
    if (ConvertTargetProducts) {
      ConvertTargetProductsArray = ConvertTargetProducts.split(',').map(productid => Number(productid))
    }
    data.ConvertTargetProducts = ConvertTargetProductsArray;
  }
  if(isGGI) {
    data.ProductMarketing_id = selectedMarketing;
  }
  if(isOLG) {
    data.IsWebDisplay = IsWebDisplay;
  }

  if (isAGD) {
    data.CartonVolume = Number(CartonWidth) * Number(CartonHeight) * Number(CartonLength);
  }
  if (isVAK) {
    data.BoxDimensionHeight = BoxDimensionHeight;
    data.BoxDimensionLength = BoxDimensionLength;
    data.BoxDimensionWidth = BoxDimensionWidth;
  }
  if (isGFD) {
    data.XFactor = XFactor,
    data.Warehouse = Warehouse && Warehouse.split(',').map(w => Number(w));
    data.IsDepartment = IsDepartment;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_PRODUCT });
    axios.post(
      PRODUCTS_URL + "?Company_id=" + selectedCompany.value + "&warehouse_id=" + selectedWarehouse.value,
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(createProductSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404 || err.status === 400) {
          // err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createProductFailure(err));
        }
      });
  };
}
export function requestCreatingProduct() {
  return {
    type: REQUEST_CREATING_PRODUCT,

  };
}
export function createProductSuccess(response) {
  return {
    type: CREATE_PRODUCT_SUCCESS,
    payload: response,
  };
}
export function createProductFailure(error) {
  return {
    type: CREATE_PRODUCT_FAILURE,
    payload: error,
  };
}

/**
 * Duplicates the current product
 * @param {number} prodId current product's id
 * @param {string} prodNum new generated product number
 */
export const duplicateProduct = (prodId, prodNum, department, group, category) => (dispatch) => {
  dispatch({ type: REQUEST_CREATING_PRODUCT });
  let data = {ProductNum: prodNum};
  if (isGFD) {
    data = {ProductNum: prodNum, ProductDepartment_id: department.value || department, ProductGroup_id: group.value || group, ProductCategory1_id: category.value || category};
  }
  const config = {
    method: 'post',
    url: `${PRODUCTS_URL}duplicate/${prodId}`,
    data: data,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    dispatch(createProductSuccess(response));
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      dispatch(createProductFailure(err));
    }
  });
};

export function editProductSuccess(response) {
  return {
    type: EDIT_PRODUCT_SUCCESS,
    payload: response,
  };
}
export function editProductFailure(error) {
  return {
    type: EDIT_PRODUCT_FAILURE,
    payload: error,
  };
}
export function editProduct({
  LevelType,
  popularity,
  IsFoodStamp,
  RefPriceMode,
  ESLCode,
  TemplateName,
  AutoPO,
  default_po_quantity,
  LimitQuantityPerOrder,
  MultipleQuantityPerOrder,
  MixedProductBaseUnit,
  MixedProduct,
  Bin,
  BinRangeList,
  ConvertNum,
  ConvertType,
  Notes,
  ProdCreateDate,
  MinOrderQty,
  ClassNo,
  CatalogPage,
  BaseCost,
  CustomDutyPercent,
  HtmsNum,
  // CaseCost,
  PromoTier1Qty,
  PromoTier2Qty,
  Units_Case,
  Units_InnerBox,
  CRV,
  CRV_id,
  FOBCost,
  Default_Warehouse_id,
  Default_WarehouseFromBin_id,
  Default_WarehouseToBin_id,
  Default_WarehouseZone_id,
  Description,
  Description2,
  Description3,
  Height,
  HMartCode,
  InStockPrice,
  InternalBarcode,
  IsB2B,
  IsB2C,
  IsDiscontinued,
  IsLarge,
  IsOverSaleable,
  IsPromotion,
  IsRelated,
  IsStopSale,
  GeneralNum,
  IsTaxable,
  msrp,
  IsAllTaxable,
  IsNonFood,
  IsWholesaleOnly,
  IsWebDisplay,
  IsMobile,
  IsSoldNationwide,
  IsSyncNuOrder,
  IsSyncShopify,
  IsRetailPack,
  IsCombo,
  IsNewArrival,
  IsGreatDeal,
  PurchaseConvertUnit,
  IsProposition65,
  IsSyncToScales,
  IsSyncToESL,
  IsAFGChioce,
  IsAlcohol,
  Length,
  Level,
  LowestSalePrice,
  MaxStockRange,
  MaxWeightRange,
  MeasureUnit,
  MeasureUnit_2,
  DimensionUnit,
  DimensionHeight,
  DimensionLength,
  DimensionWidth,
  BoxDimensionHeight,
  BoxDimensionLength,
  BoxDimensionWidth,
  CartonWidth,
  CartonHeight,
  CartonLength,
  CartonWeight,
  CaseHeight,
  CaseLength,
  CaseWidth,
  PalletHeight,
  PalletLength,
  PalletWidth,
  UnitCBF,
  UnitCBM,
  CaseCBF,
  CaseCBM,
  PalletCBF,
  PalletCBM,
  CasePerPallet,
  Volume,
  MinStockRange,
  MinWeightRange,
  Name,
  NetCost,
  NetWeight,
  CaseWt,
  BoxWt,
  PackageSize,
  PackageSize_1,
  PackageSize_2,
  CalcoDispatchCase,
  CalcoDispatchBag,
  PackageType,
  PackageType_2,
  PriceType,
  Product_id,
  ProductBarcode,
  ProductCategory1_id,
  ProductCategory2_id,
  ProductCost,
  ProductGroup_id,
  ProductDepartment_id,
  ProductNum,
  ProductType,
  Tare,
  DateFlag,
  Purchaser_User_id,
  IsStopPurchase,
  Sales_User_id,
  RefNum,
  RefPrice,
  Related_Product_id,
  RoundPriceLevels,
  ShiftLife,
  BufferTime,
  ShippingWeight,
  UnitPerPallet,
  VendorProdNo,
  Vendors,
  Width,
  Zone,
  ViewableLanguages,
  ShippingFeeUnitPrice,
  TaxAmount,
  Temperature,
  MiscUnitPrice,
  Brand,
  SubjectCategory,
  TopFlag,
  Zone2,
  Bin2,
  Level2,
  Zone3,
  Bin3,
  Level3,
  TJXStyleNum,
  UPC,
  GTIN,
  Color,
  Size,
  English_Details_Brand,
  Chinese_Details_Brand,
  English_Brand_Origin,
  Chinese_Brand_Origin,
  English_Details_NetContent,
  Chinese_Details_NetContent,
  English_Details_Made_In,
  Chinese_Details_Made_In,
  English_Details_Organic,
  Chinese_Details_Organic,
  English_Details_Contains_Sugar,
  Chinese_Details_Contains_Sugar,
  English_Details_Flavor,
  Chinese_Details_Flavor,
  English_Details_Ingredients,
  Chinese_Details_Ingredients,
  PackageSize_3,
  MeasureUnit_3,
  PalletSize,
  MadeIn,
  FW,
  CustomerStr,
  Channel,
  ActualNW,
  InventoryIsMobile,
  ItemMeasurement,
  CategoryNum,
  SyncInventory,
  GLaccount,
  // isSH
  ItemName,
  ColorCode,
  QBItemNum,
  RootDescription,
  PackingSizeCode,
  RootItemName,
  RootItemNum,
  OldPrintNum,
  ShortColorCode,
  BackColor,
  DesignPrintNum,
  ShortName,
  BoxPacking,
  AmazonItemNum,
  AmazonBoxPacking,
  AmazonSKU,
  AmazonPrice,
  RelocateTargetProduct,
  FrontPOColor,
  BackPOColor,
  // angel dear
  Type,
  ShortDescription,
  Gender,
  NRF_Color_Code,
  NRF_Size_Code,
  US_HTS_Codes,
  CartonVolume,
  CartonInnerQuantity,
  CartonQuantity,
  ProductFamilySKU,
  ProductFamilyName,
  ProductFamilyOption1Name,
  ProductFamilyOption1Value,
  ProductFamilyOption2Name,
  ProductFamilyOption2Value,
  ProductFamilyOption3Name,
  ProductFamilyOption3Value,
  ConvertTargetProducts,
  XFactor,
  Warehouse,
  IsDepartment,
}, {
  priceLv1,
  priceLv2,
  priceLv3,
  priceLv4,
  priceLv5,
  p1Percentage,
  p2Percentage,
  p3Percentage,
  p4Percentage,
  p5Percentage,
  relatedProducts,
  productParts,
  ProductSKU,
  meta_info,
  selectedCompany,
  selectedWarehouse,
  selectedMarketing,
}, returnToLastPage) {
  
  if (MadeIn) MadeIn = MadeIn.value || MadeIn;
  if (FW) FW = FW.value || FW;
  if (CustomerStr) CustomerStr = CustomerStr.value || CustomerStr;
  
  if (GTIN) GTIN = GTIN.value || GTIN;

  if (Channel) Channel = Channel.value || Channel;

  let ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost);
  let CustomDutyCost = (Number(CustomDutyPercent ? CustomDutyPercent : 0)/100) * Number(BaseCost);
  if (isSV) {
    ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost) + CustomDutyCost;
  }
  if(isHMM) {
    ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost) + Number(TaxAmount);
  }

  if (isAGD) {
    CartonVolume = Number(CartonWidth) * Number(CartonHeight) * Number(CartonLength);
  }
  const newVendors = [];
  if (Vendors) {
    Vendors.map((vendor) => {
      if (vendor.Vendor_id) {
        vendor.Vendor_id = vendor.Vendor_id.value || vendor.Vendor_id;
      }
      if (vendor.Source) {
        vendor.Source = vendor.Source.value || vendor.Source;
      }
      newVendors.push(vendor);
    });
  }

  if (Related_Product_id) Related_Product_id = Related_Product_id.value || Related_Product_id;
  if (ProductGroup_id) ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
  if (ProductDepartment_id) ProductDepartment_id = ProductDepartment_id.value || ProductDepartment_id;
  if (ProductCategory1_id) ProductCategory1_id = ProductCategory1_id.value || ProductCategory1_id;
  if (ProductCategory2_id) ProductCategory2_id = ProductCategory2_id.value || ProductCategory2_id;
  if (PackageType) PackageType = PackageType.value || PackageType;
  if (ProductType) ProductType = ProductType.value || ProductType;
  if (DateFlag) DateFlag = DateFlag.value || DateFlag;
  if (Default_Warehouse_id) Default_Warehouse_id = Default_Warehouse_id.value || Default_Warehouse_id;
  if (Default_WarehouseZone_id) Default_WarehouseZone_id = Default_WarehouseZone_id.value || Default_WarehouseZone_id;
  if (!IsDiscontinued) IsDiscontinued = 'false';
  if (!IsTaxable) IsTaxable = 'false';
  if (!IsAllTaxable) IsAllTaxable = 'false';
  if (!IsNonFood) IsNonFood = 'false';
  if (!IsOverSaleable) IsOverSaleable = 'false';
  if (!IsPromotion) IsPromotion = 'false';
  if (!IsWholesaleOnly) IsWholesaleOnly = 'false';
  if (PackageType_2) PackageType_2 = PackageType_2.value || PackageType_2;
  if (MeasureUnit_2) MeasureUnit_2 = MeasureUnit_2.value || MeasureUnit_2;
  if (MeasureUnit) { MeasureUnit = MeasureUnit.value || MeasureUnit; }
  if (TemplateName) TemplateName = TemplateName.value || TemplateName;
  if (GLaccount) GLaccount = GLaccount.value || GLaccount;
  if (popularity) popularity = popularity.value || popularity;
  if (RelocateTargetProduct) RelocateTargetProduct = RelocateTargetProduct.value || RelocateTargetProduct
  const mixedProduct = [];
  if (MixedProduct) {
    for (var i = 0; i < MixedProduct.length; i++) {
      let temp = {};
      if (MixedProductBaseUnit.value) {
        temp.Unit = MixedProductBaseUnit.value;
      } else {
        temp.Unit = MixedProductBaseUnit;
      }
      if(MixedProduct[i].MixedUnit.value) {
        temp.MixedUnit = MixedProduct[i].MixedUnit.value;
      } else {
        temp.MixedUnit = MixedProduct[i].MixedUnit;
      }
      temp.ProductName = MixedProduct[i].ProductName;
      temp.ProductNum = MixedProduct[i].ProductNum;
      temp.ProductSKU = MixedProduct[i].ProductSKU;
      temp.Quantity = MixedProduct[i].Quantity;
      mixedProduct[i] = temp;
    }
  }

  if ( !isNumeric(LimitQuantityPerOrder) ) {
    if ( LimitQuantityPerOrder === null || LimitQuantityPerOrder === "" || !LimitQuantityPerOrder ) {
      LimitQuantityPerOrder = 0;
    } else {
      alert("Limited Qty/Order must be a number!");
      return (dispatch) => {
        dispatch({ type: EDIT_PRODUCT_FAILURE });
      }
    }
  }
  if (LimitQuantityPerOrder < 0) {
    LimitQuantityPerOrder = 0;
  }

  if ( !isNumeric(MultipleQuantityPerOrder) ) {
    if ( MultipleQuantityPerOrder === null || MultipleQuantityPerOrder === "" || !MultipleQuantityPerOrder ) {
      MultipleQuantityPerOrder = 0;
    } else {
      alert("Multiple Qty/Order must be a number!");
      return (dispatch) => {
        dispatch({ type: EDIT_PRODUCT_FAILURE });
      }
    }
  }
  if (MultipleQuantityPerOrder < 0) {
    MultipleQuantityPerOrder = 0;
  }

  let binRangeList = [];
  if (BinRangeList) {
    binRangeList = BinRangeList.slice();
    BinRangeList.map((bin, index) => {
      if ((typeof bin.DefaultBin === 'object') && bin.DefaultBin.value) {
        binRangeList[index].DefaultBin = bin.DefaultBin.value;
      } else {
        binRangeList[index].DefaultBin = bin.DefaultBin;
      }
      if ((typeof bin.Default_Level === 'object') && bin.Default_Level.value) {
        binRangeList[index].Default_Level = bin.Default_Level.value;
      } else {
        binRangeList[index].Default_Level = bin.Default_Level;
      }
    });
  }
  if (DimensionUnit && DimensionUnit.value) {
    DimensionUnit = DimensionUnit.value;
  }
  if (RefPriceMode && RefPriceMode.value) {
    RefPriceMode = RefPriceMode.value;
  }
  if (RefPriceMode === 'avg_cost') {
    RefPrice = InStockPrice;
  }
  if (RefPriceMode === 'prod_cost') {
    RefPrice = ProductCost;
  }
  let data = {
    LevelType,
    popularity,
    IsFoodStamp,
    RefPriceMode,
    ESLCode,
    TemplateName,
    IsSyncToESL,
    AutoPO,
    default_po_quantity,
    meta_title: meta_info.meta_title,
    meta_keywords: meta_info.meta_keywords,
    meta_description: meta_info.meta_description,
    LimitQuantityPerOrder,
    MultipleQuantityPerOrder,
    MixedProduct: mixedProduct,
    Bin,
    BinRangeList: binRangeList,
    ConvertNum,
    ConvertType,
    CRV,
    CRV_id: (CRV_id && CRV_id.value) || CRV_id,
    FOBCost,
    Notes,
    ProdCreateDate,
    MinOrderQty,
    ClassNo,
    CatalogPage,
    BaseCost,
    CustomDutyPercent,
    HtmsNum,
    // CaseCost,
    PromoTier1Qty,
    PromoTier2Qty,
    Units_Case,
    Units_InnerBox,
    Default_Warehouse_id,
    Default_WarehouseFromBin_id,
    Default_WarehouseToBin_id,
    Default_WarehouseZone_id,
    Description,
    Description2,
    Description3,
    Height,
    HMartCode,
    InStockPrice,
    InternalBarcode,
    IsDiscontinued,
    IsB2B,
    IsB2C,
    IsLarge,
    IsOverSaleable,
    IsPromotion,
    IsRelated,
    IsStopSale,
    GeneralNum,
    IsTaxable,
    msrp,
    IsAllTaxable,
    IsNonFood,
    IsWholesaleOnly,
    IsMobile,
    IsSoldNationwide,
    IsSyncNuOrder,
    IsSyncShopify,
    IsRetailPack,
    IsCombo,
    IsNewArrival,
    IsGreatDeal,
    PurchaseConvertUnit,
    IsProposition65,
    IsSyncToScales,
    IsAFGChioce,
    IsAlcohol,
    Length,
    Level,
    LowestSalePrice,
    MaxStockRange,
    MaxWeightRange,
    MeasureUnit,
    MeasureUnit_2,
    DimensionUnit,
    DimensionHeight,
    DimensionLength,
    DimensionWidth,
    CartonWidth,
    CartonHeight,
    CartonLength,
    CartonWeight,
    CaseHeight,
    CaseLength,
    CaseWidth,
    PalletHeight,
    PalletLength,
    PalletWidth,
    UnitCBF,
    UnitCBM,
    CaseCBF,
    CaseCBM,
    PalletCBF,
    PalletCBM,
    CasePerPallet,
    Volume,
    MinStockRange,
    MinWeightRange,
    Name,
    NetCost,
    NetWeight,
    CaseWt,
    BoxWt,
    P1Percentage: p1Percentage,
    P2Percentage: p2Percentage,
    P3Percentage: p3Percentage,
    P4Percentage: p4Percentage,
    P5Percentage: p5Percentage,
    PackageSize,
    PackageSize_1,
    PackageSize_2,
    CalcoDispatchCase,
    CalcoDispatchBag,
    PackageType,
    PackageType_2,
    PriceLv1: priceLv1,
    PriceLv2: priceLv2,
    PriceLv3: priceLv3,
    PriceLv4: priceLv4,
    PriceLv5: priceLv5,
    PromoPrice1: priceLv1,
    PromoPrice2: priceLv2,
    PromoPrice3: priceLv3,
    PriceType,
    ProductBarcode,
    ProductCategory1_id,
    ProductCategory2_id,
    ProductCost,
    ProductGroup_id,
    ProductDepartment_id,
    ProductNum,
    ProductType,
    Tare,
    DateFlag,
    Purchaser_User_id: (Purchaser_User_id && Purchaser_User_id.value) || Purchaser_User_id,
    IsStopPurchase,
    Sales_User_id: (Sales_User_id && Sales_User_id.value) || Sales_User_id,
    RefNum,
    RefPrice,
    Related_Product_id,
    relations: relatedProducts,
    relations2: productParts.rows,
    RoundPriceLevels,
    ShiftLife,
    BufferTime,
    ShippingWeight,
    UnitPerPallet,
    VendorProdNo,
    Vendors: newVendors,
    Width,
    Zone,
    ViewableLanguages,
    ProductSKU,
    ShippingFeeUnitPrice,
    TaxAmount,
    Temperature,
    MiscUnitPrice,
    ArrivalPrice,
    CustomDutyCost,
    Brand,
    SubjectCategory,
    TopFlag,
    Zone2,
    Bin2,
    Level2,
    Zone3,
    Bin3,
    Level3,
    TJXStyleNum,
    UPC,
    GTIN,
    Color,
    Size,
    English_Details_Brand,
    Chinese_Details_Brand,
    English_Brand_Origin,
    Chinese_Brand_Origin,
    English_Details_NetContent,
    Chinese_Details_NetContent,
    English_Details_Made_In,
    Chinese_Details_Made_In,
    English_Details_Organic,
    Chinese_Details_Organic,
    English_Details_Contains_Sugar,
    Chinese_Details_Contains_Sugar,
    English_Details_Flavor,
    Chinese_Details_Flavor,
    English_Details_Ingredients,
    Chinese_Details_Ingredients,
    PackageSize_3: PackageSize_3 || '',
    MeasureUnit_3: MeasureUnit_3 ? (MeasureUnit_3.value || MeasureUnit_3) : '',
    PalletSize,
    MadeIn,
    FW,
    CustomerStr,
    Channel,
    ActualNW,
    InventoryIsMobile,
    ItemMeasurement,
    CategoryNum,
    SyncInventory,
    GLaccount,
    // isSH
    ItemName,
    ColorCode,
    QBItemNum,
    RootDescription,
    PackingSizeCode,
    RootItemName,
    RootItemNum,
    OldPrintNum,
    ShortColorCode,
    BackColor,
    DesignPrintNum,
    ShortName,
    BoxPacking,
    AmazonItemNum,
    AmazonBoxPacking,
    AmazonSKU,
    AmazonPrice,
    RelocateTargetProduct,
    FrontPOColor,
    BackPOColor,
    // angel dear
    Type,
    ShortDescription,
    Gender,
    NRF_Color_Code,
    NRF_Size_Code,
    US_HTS_Codes,
    CartonVolume,
    CartonInnerQuantity,
    CartonQuantity,
    ProductFamilySKU,
    ProductFamilyName,
    ProductFamilyOption1Name,
    ProductFamilyOption1Value,
    ProductFamilyOption2Name,
    ProductFamilyOption2Value,
    ProductFamilyOption3Name,
    ProductFamilyOption3Value
  }
  if(isTQ) {
    let ConvertTargetProductsArray = [];
    if (ConvertTargetProducts) {
      ConvertTargetProductsArray = ConvertTargetProducts.split(',').map(productid => Number(productid))
    }
    data.ConvertTargetProducts = ConvertTargetProductsArray;
  }
  if(isGGI) {
    data.ProductMarketing_id = selectedMarketing;
  }
  if(isOLG) {
    data.IsWebDisplay = IsWebDisplay;
  }
  if (isVAK) {
    data.BoxDimensionHeight = BoxDimensionHeight;
    data.BoxDimensionLength = BoxDimensionLength;
    data.BoxDimensionWidth = BoxDimensionWidth;
  }
  if (isAGD) {
    data.CartonVolume = Number(CartonWidth) * Number(CartonHeight) * Number(CartonLength);
  }
  if (isGFD) {
    data.XFactor = XFactor,
    data.Warehouse = Warehouse && Warehouse.split(',').map(w => Number(w));
    data.IsDepartment = IsDepartment;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_PRODUCT });

    axios.put(
      (PRODUCTS_URL + Product_id + "?Company_id=" + selectedCompany.value + "&warehouse_id=" + selectedWarehouse.value),
      data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        if (returnToLastPage) {
          browserHistory.goBack();
        }
        dispatch(editProductSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404 || err.status === 400) {
          // err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editProductFailure(err));
        }
      });
  };
}

export function editMultiProductSuccess() {
  return {
    type: EDIT_MULTI_PRODUCT_SUCCESS,
  };
}
export function editMultiProductFailure(error) {
  return {
    type: EDIT_MULTI_PRODUCT_FAILURE,
    payload: error,
  };
}
export function editMultiProducts(editedProducts) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_MULTI_PRODUCT });
    axios.put(
      (PRODUCTS_URL),
      editedProducts,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiProductSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiProductFailure(err));
        }
      });
  };
}

// Fetch the detail page
export function requestProductDetail() {
  return {
    type: REQUEST_PRODUCT_DETAIL,
  };
}
export function fetchProductDetailSuccess(productDetail) {
  productDetail = productDetail.data;
  if (isTQ) {
    productDetail = mapTQProdDetails(productDetail)
  }
  if (isGFD) {
    productDetail = mapGFDProdDetails(productDetail)
  }
  return {
    type: FETCH_PRODUCT_DETAIL_SUCCESS,
    payload: productDetail,
  };
}
export function fetchProductDetailFailure(error) {
  return {
    type: FETCH_PRODUCT_DETAIL_FAILURE,
    payload: error,
  };
}
export function fetchProductDetail(product_id, company_id, warehouse_id) {
  return (dispatch) => {
    dispatch(requestProductDetail());
    let cid = null;
    if (company_id && company_id.value) {
      cid = company_id.value
    }
    let wid = null;
    if (warehouse_id && warehouse_id.value) {
      wid = warehouse_id.value
    }
    if (!wid) return;
    // let url = PRODUCTS_URL + product_id + "?Company_id=" + cid;
    return axios.get(
      PRODUCTS_URL + product_id + "?Company_id=" + cid + "&warehouse_id=" + wid,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductDetailFailure(err));
        }
      });
  };
}

// Product Group Actions
export function resetGroupAndCategory() {
  return {
    type: RESET_GROUP_AND_CATEGORY,
  };
}

export function requestGroups() {
  return {
    type: REQUEST_GROUPS,
  };
}
export function fetchGroupsSuccess(groups) {
  return {
    type: FETCH_GROUPS_SUCCESS,
    payload: groups,
  };
}
export function fetchGroupsFailure(error) {
  return {
    type: FETCH_GROUPS_FAILURE,
    payload: error,
  };
}
export function fetchGroups(isFilter = false) {
  return (dispatch) => {
    dispatch(requestGroups());
    let enableFilter = '';
    if (isAGD && isFilter) {
      enableFilter='?enabled=True';
    }
    
    return axios.get(
      `${GROUPS_URL}${enableFilter}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchGroupsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchGroupsFailure(err));
        }
      });
  };
}

export function requestDeps() {
  return {
    type: REQUEST_DEPS,
  };
}
export function fetchDepsSuccess(groups) {
  return {
    type: FETCH_DEPS_SUCCESS,
    payload: groups,
  };
}
export function fetchDeps(buyer) {
  let url = DEP_URL;
  if (buyer && buyer !== 'All') {
    url = DEP_URL + '?BuyerId=' + buyer;
  }
  return (dispatch) => {
    dispatch(requestDeps());
    return axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDepsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchGroupsFailure(err));
        }
      });
  };
}


export function selectGroup(group) {
  return {
    type: SELECT_GROUP,
    payload: group,
  };
}
export function selectDep(dep) {
  return {
    type: SELECT_DEP,
    payload: dep,
  };
}


export function resetCurrentGroup() {
  return {
    type: RESET_CURRENT_GROUP,
  };
}

export function createGroupSuccess() {
  return {
    type: CREATE_GROUP_SUCCESS,
  };
}
export function createGroupFailure(error) {
  return {
    type: CREATE_GROUP_FAILURE,
    payload: error,
  };
}
export function createGroup({
  Name,
  Description,
  IsEnabled,
}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_GROUP });
    axios.post(
      GROUPS_URL,
      {
        Name,
        Description,
        IsEnabled,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(createGroupSuccess());
        browserHistory.push('/products/groups');
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createGroupFailure(err));
        }
      });
  };
}

export function editGroupSuccess() {
  return {
    type: EDIT_GROUP_SUCCESS,
  };
}
export function editGroupFailure(error) {
  return {
    type: EDIT_GROUP_FAILURE,
    payload: error,
  };
}
export function editGroup({
  ProductGroup_id,
  Name,
  Description,
  IsEnabled,
}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_GROUP });
    axios.put(
      (GROUPS_URL + ProductGroup_id),
      {
        Name,
        Description,
        IsEnabled,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editGroupSuccess());
        browserHistory.push('/products/groups'); // If editd succesfully, refresh the paymentTerm page.
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editGroupFailure(err));
        }
      });
  };
}

export function editMultiGroupsSuccess() {
  return {
    type: EDIT_MULTI_GROUPS_SUCCESS,
  };
}
export function editMultiGroupsFailure(error) {
  return {
    type: EDIT_MULTI_GROUPS_FAILURE,
    payload: error,
  };
}
export function editMultiGroups(editedGroups) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_MULTI_GROUPS });
    axios.put(
      (GROUPS_URL),
      editedGroups,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiGroupsSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiGroupsFailure(err));
        }
        // if 400 error, dont override its message
      });
  };
}


export function editMultiDepssSuccess() {
  return {
    type: EDIT_MULTI_DEPS_SUCCESS,
  };
}
export function editMultiDeps(editedGroups) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_MULTI_DEPS });
    axios.put(
      (DEP_URL),
      editedGroups,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiDepssSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        // if 400 error, dont override its message
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiGroupsFailure(err));
        }
      });
  };
}

// Product Categories Actions
export function requestCategories() {
  return {
    type: REQUEST_CATEGORIES,
  };
}
export function fetchCategoriesSuccess(categories) {
  return {
    type: FETCH_CATEGORIES_SUCCESS,
    payload: categories,
  };
}
export function fetchCategoriesFailure(error) {
  return {
    type: FETCH_CATEGORIES_FAILURE,
    payload: error,
  };
}
export function fetchCategories() {
  return (dispatch) => {
    dispatch(requestCategories());
    return axios.get(
      CATEGORIES_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCategoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCategoriesFailure(err));
        }
      });
  };
}

export function resetCategory() {
  return {
    type: RESET_CATEGORY,
  };
}
export function selectCategory(category) {
  return {
    type: SELECT_CATEGORY,
    payload: category,
  };
}
export function selectCategoryB2B(category) {
  return {
    type: SELECT_CATEGORY_B2B,
    payload: category,
  };
}

export function resetCurrentCategory() {
  return {
    type: RESET_CURRENT_CATEGORY,
  };
}
export function resetCurrentCategoryB2B() {
  return {
    type: RESET_CURRENT_CATEGORY_B2B,
  };
}

export function requestCreatingCategory() {
  return {
    type: REQUEST_CREATING_CATEGORY,
  };
}
export function createCategorySuccess() {
  return {
    type: CREATE_CATEGORY_SUCCESS,
  };
}
export function createCategoryFailure(error) {
  return {
    type: CREATE_CATEGORY_FAILURE,
    payload: error,
  };
}
export function createCategory({
  Name,
  Description,
  IsEnabled,
  ProductGroup_id,
}, type) {
  ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
  return (dispatch) => {
    dispatch({ type: REQUEST_CREATING_CATEGORY });
    axios.post(
      CATEGORIES_URL,
      {
        Name,
        Description,
        IsEnabled,
        ProductGroup_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(createCategorySuccess());
        if (type !== 'productForm') { browserHistory.push('/products/categories'); }
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(createCategoryFailure(err));
        }
      });
  };
}

export function editCategorySuccess() {
  return {
    type: EDIT_CATEGORY_SUCCESS,
  };
}
export function editCategoryFailure(error) {
  return {
    type: EDIT_CATEGORY_FAILURE,
    payload: error,
  };
}
export function editCategory({
  ProductCategory_id,
  Name,
  Description,
  IsEnabled,
  ProductGroup_id,
}) {
  ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_CATEGORY });
    axios.put(
      (CATEGORIES_URL + ProductCategory_id),
      {
        Name,
        Description,
        IsEnabled,
        ProductGroup_id,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editCategorySuccess());
        browserHistory.push('/products/categories'); // If editd succesfully, refresh the paymentTerm page.
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editCategoryFailure(err));
        }
      });
  };
}

export function editMultiCategoriesSuccess() {
  return {
    type: EDIT_MULTI_CATEGORIES_SUCCESS,
  };
}
export function editMultiCategoriesFailure(error) {
  return {
    type: EDIT_MULTI_CATEGORIES_FAILURE,
    payload: error,
  };
}
export function editMultiCategories(editedCategoriess) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_MULTI_CATEGORIES });
    axios.put(
      (CATEGORIES_URL),
      editedCategoriess,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiCategoriesSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiCategoriesFailure(err));
        }
      });
  };
}

export function requestCategories2() {
  return {
    type: REQUEST_CATEGORIES_2,
  };
}
export function fetchCategories2Success(categories) {
  return {
    type: FETCH_CATEGORIES_2_SUCCESS,
    payload: categories,
  };
}
export function fetchCategories2Failure(error) {
  return {
    type: FETCH_CATEGORIES_2_FAILURE,
    payload: error,
  };
}
export function fetchCategories2() {
  return (dispatch) => {
    dispatch(requestCategories2());
    return axios.get(
      CATEGORIES_2_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCategories2Success(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCategories2Failure(err));
        }
      });
  };
}

export function requestCategories2B2B() {
  return {
    type: REQUEST_CATEGORIES_2_B2B,
  };
}
export function fetchCategories2SuccessB2B(categories) {
  return {
    type: FETCH_CATEGORIES_2_SUCCESS_B2B,
    payload: categories,
  };
}
export function fetchCategories2FailureB2B(error) {
  return {
    type: FETCH_CATEGORIES_2_FAILURE_B2B,
    payload: error,
  };
}
export function fetchCategories2B2B() {
  return (dispatch) => {
    dispatch(requestCategories2B2B());
    return axios.get(
      CATEGORIES_2_B2B_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCategories2SuccessB2B(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCategories2FailureB2B(err));
        }
      });
  };
}

export function editMultiCategories2Success() {
  return {
    type: EDIT_MULTI_CATEGORIES_2_SUCCESS,
  };
}
export function editMultiCategories2Failure(error) {
  return {
    type: EDIT_MULTI_CATEGORIES_2_FAILURE,
    payload: error,
  };
}
export function editMultiCategories2(editedCategories) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_MULTI_CATEGORIES_2 });
    axios.put(
      (CATEGORIES_2_URL),
      editedCategories,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiCategories2Success());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiCategories2Failure(err));
        }
      });
  };
}

export function editMultiCategories2SuccessB2B() {
  return {
    type: EDIT_MULTI_CATEGORIES_2_SUCCESS_B2B,
  };
}
export function editMultiCategories2FailureB2B(error) {
  return {
    type: EDIT_MULTI_CATEGORIES_2_FAILURE_B2B,
    payload: error,
  };
}
export function editMultiCategories2B2B(editedCategories) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_MULTI_CATEGORIES_2_B2B });
    axios.put(
      (CATEGORIES_2_B2B_URL),
      editedCategories,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiCategories2SuccessB2B());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiCategories2FailureB2B(err));
        }
      });
  };
}

export function deleteCategory2Success() {
  return {
    type: DELETE_CATEGORY_2_SUCCESS,
  };
}
export function deleteCategory2Failure(error) {
  return {
    type: DELETE_CATEGORY_2_FAILURE,
    payload: error,
  };
}
export function deleteCategory2(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_CATEGORY_2 });
    axios.delete(
      CATEGORIES_2_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(deleteCategory2Success());
        dispatch(fetchCategories2());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteCategory2Failure(err));
        }
      });
  };
}

export function deleteCategory2SuccessB2B() {
  return {
    type: DELETE_CATEGORY_2_SUCCESS_B2B,
  };
}
export function deleteCategory2FailureB2B(error) {
  return {
    type: DELETE_CATEGORY_2_FAILURE_B2B,
    payload: error,
  };
}
export function deleteCategory2B2B(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_CATEGORY_2_B2B });
    axios.delete(
      CATEGORIES_2_B2B_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(deleteCategory2SuccessB2B());
        dispatch(fetchCategories2B2B());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteCategory2FailureB2B(err));
        }
      });
  };
}

export function clearCategory2Status() {
  return {
    type: CLEAR_CATEGORY_2_STATUS,
  };
}

export function clearCategory2StatusB2B() {
  return {
    type: CLEAR_CATEGORY_2_STATUS_B2B,
  };
}

// Product Types Actions
export function requestTypes() {
  return {
    type: REQUEST_TYPES,
  };
}
export function fetchTypesSuccess(types) {
  return {
    type: FETCH_TYPES_SUCCESS,
    payload: types,
  };
}
export function fetchTypesFailure(error) {
  return {
    type: FETCH_TYPES_FAILURE,
    payload: error,
  };
}
export function fetchTypes() {
  return (dispatch) => {
    dispatch(requestTypes());
    return axios.get(
      TYPES_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchTypesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchTypesFailure(err));
        }
      });
  };
}

// Product Pricelevel Actions
export function requestPriceLevels() {
  return {
    type: REQUEST_PRICELEVELS,
  };
}
export function fetchPriceLevelsSuccess(priceLevels) {
  return {
    type: FETCH_PRICELEVELS_SUCCESS,
    payload: priceLevels,
  };
}
export function fetchPriceLevelsFailure(error) {
  return {
    type: FETCH_PRICELEVELS_FAILURE,
    payload: error,
  };
}
export function fetchPriceLevels(type, id) {
  let query = '';
  if (type !== 'All') {
    query = `${type}=${id}&`;
  }
  return (dispatch, getState) => {
    dispatch(requestPriceLevels());
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const selectedWarehouse = state.header.selectedWarehouse;
    if (!selectedCompany.value) return;
    query = `?${query}company_id=${selectedCompany.value}`;
    if (selectedWarehouse && selectedWarehouse.value && selectedWarehouse.value !== '0') {
      query = `${query}&warehouse_id=${selectedWarehouse.value}`;
    }
    return axios.get(
      `${PRODUCTS_URL}pricelevel/${query}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPriceLevelsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPriceLevelsFailure(err));
        }
      });
  };
}

export function editMultiPriceLevelsSuccess() {
  return {
    type: EDIT_MULTI_PRICELEVELS_SUCCESS,
  };
}
export function editMultiPriceLevelsFailure(error) {
  return {
    type: EDIT_MULTI_PRICELEVELS_FAILURE,
    payload: error,
  };
}
export function editMultiPriceLevels(editedPriceLevels) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    dispatch({ type: REQUEST_EDITING_MULTI_PRICELEVELS });
    axios.put(
      (`${PRICELEVELS_URL}?company_id=${selectedCompany.value}`),
      editedPriceLevels,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(editMultiPriceLevelsSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMultiPriceLevelsFailure(err));
        }
      });
  };
}

export function fetchSimplifiedProductsSuccess(products) {
  return {
    type: FETCH_SIMPLIFIED_PRODUCTS_SUCCESS,
    payload: products,
  };
}
export function fetchSimplifiedProductsFailure(error) {
  return {
    type: FETCH_SIMPLIFIED_PRODUCTS_FAILURE,
    payload: error,
  };
}
export function fetchSimplifiedProducts(searchType, searchValue) {
  let RESEARCH_URL = '';
  if (searchType && searchValue) {
    RESEARCH_URL = `?${searchType}=${searchValue}`;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_SIMPLIFIED_PRODUCTS });
    axios.get(
      PRODUCTS_SIMPLIFIED_URL + RESEARCH_URL,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSimplifiedProductsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSimplifiedProductsFailure(err));
        }
      });
  };
}

export function fetchGroupCategoriesSuccess(categories) {
  return {
    type: FETCH_GROUP_CATEGORIES_SUCCESS,
    payload: categories,
  };
}
export function fetchGroupCategoriesSuccessAlt(categories) {
  return {
    type: FETCH_GROUP_CATEGORIES_SUCCESS_ALT,
    payload: categories,
  };
}

export function fetchGroupCategoriesFailure(error) {
  return {
    type: FETCH_GROUP_CATEGORIES_FAILURE,
    payload: error,
  };
}
export function fetchGroupCategories(group_id, alt) {
  return (dispatch) => {
    dispatch({ type: (alt && isGFD) ? REQUEST_GROUP_CATEGORIES_ALT : REQUEST_GROUP_CATEGORIES });
    axios.get(
      `${GROUPS_URL}categories/${group_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch((alt && isGFD) ? fetchGroupCategoriesSuccessAlt(response) : fetchGroupCategoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchGroupCategoriesFailure(err));
        }
      });
  };
}

export function fetchDepCategoriesSuccess(categories) {
  return {
    type: FETCH_DEP_CATEGORIES_SUCCESS,
    payload: categories,
  };
}
export function fetchDepCategoriesSuccessAlt(categories) {
  return {
    type: FETCH_DEP_CATEGORIES_SUCCESS_ALT,
    payload: categories,
  };
}
export function fetchDepCategories(group_id, alt) {
  return (dispatch) => {
    dispatch({ type: (alt && isGFD) ? REQUEST_DEP_CATEGORIES_ALT : REQUEST_DEP_CATEGORIES });
    axios.get(
      `${DEP_URL}groups/${group_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch((alt && isGFD) ? fetchDepCategoriesSuccessAlt(response) : fetchDepCategoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchGroupCategoriesFailure(err));
        }
      });
  };
}

export function setValue(form, field, value) {
  return (dispatch) => {
    dispatch(change(form, field, value));
  };
}

export function fetchProductByNumSuccess(details) {
  return {
    type: FETCH_PRODUCT_BY_NUM_SUCCESS,
    payload: details,
  };
}
export function fetchProductByNumFailure(error) {
  return {
    type: FETCH_PRODUCT_BY_NUM_FAILURE,
    payload: error,
  };
}
export function fetchProductByNum(ProductNum, company_id, warehouse_id, { isHMM, GeneralNumber }) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_NUM });
    axios.get(
      `${PRODUCTS_URL}search/?${isHMM ? 'GeneralNum' : 'ProductNum'}=${isHMM ? GeneralNumber : ProductNum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductByNumSuccess(response));
        dispatch(fetchProductDetail(response.data[0].Product_id, company_id, warehouse_id));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductByNumFailure(err));
        }
      });
  };
}

export function fetchNextProduct(id, company_id, warehouse_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_NUM });
    axios.get(
      `${PRODUCTS_URL}next/${id}?Company_id=${company_id.value}&warehouse_id=${warehouse_id.value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductDetailFailure(err));
        }
      });
  };
}

export function fetchNextProductWithGeno(GeneralNum, company_id, warehouse_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_NUM });
    axios.get(
      `${PRODUCTS_URL}nextGeneralNum/${GeneralNum}?Company_id=${company_id.value}&warehouse_id=${warehouse_id.value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductDetailFailure(err));
        }
      });
  };
}

export function fetchPreviousProduct(id, company_id, warehouse_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_NUM });
    axios.get(
      `${PRODUCTS_URL}previous/${id}?Company_id=${company_id.value}&warehouse_id=${warehouse_id.value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductDetailFailure(err));
        }
      });
  };
}

export function fetchPreviousProductWithGeno(GeneralNum, company_id, warehouse_id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_BY_NUM });
    axios.get(
      `${PRODUCTS_URL}previousGeneralNum/${GeneralNum}?Company_id=${company_id.value}&warehouse_id=${warehouse_id.value}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchProductDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchProductDetailFailure(err));
        }
      });
  };
}

export function deleteCategorySuccess() {
  return {
    type: DELETE_CATEGORY_SUCCESS,
  };
}
export function deleteCategoryFailure(error) {
  return {
    type: DELETE_CATEGORY_FAILURE,
    payload: error,
  };
}
export function deleteCategory(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_CATEGORY });
    axios.delete(
      CATEGORIES_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(deleteCategorySuccess());
        dispatch(fetchCategories());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteCategoryFailure(err));
        }
      });
  };
}

export function clearDeleteCategoryStatus() {
  return {
    type: CLEAR_CATEGORY_STATUS,
  };
}

// DELETE GROUP --- DELETE GROUP --- DELETE GROUP --- DELETE GROUP --- DELETE GROUP
export function deleteGroupSuccess() {
  return {
    type: DELETE_PRODUCT_GROUP_SUCCESS,
  };
}
export function deleteGroupFailure(error) {
  return {
    type: DELETE_GROUP_FAILURE,
    payload: error,
  };
}
export function clearDeleteGroupStatus() {
  return {
    type: CLEAR_GROUP_STATUS,
  };
}

export function deleteDepSuccess() {
  return {
    type: DELETE_PRODUCT_DEP_SUCCESS,
  };
}
export function deleteDep(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_DEP });
    axios.delete(
      DEP_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(deleteDepSuccess());
        dispatch(fetchDeps());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteGroupFailure(err));
        }
      });
  };
}

export function deleteGroup(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_GROUP });
    axios.delete(
      GROUPS_URL + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(deleteGroupSuccess());
        dispatch(fetchGroups());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteGroupFailure(err));
        }
      });
  };
}

// FETCH
export function fetchSmallProductInfoSuccess(info) {
  return {
    type: FETCH_SMALL_PRODUCT_INFO_SUCCESS,
    payload: info,
  };
}
export function fetchSmallProductInfoFailure(error) {
  return {
    type: FETCH_SMALL_PRODUCT_INFO_FAILURE,
    payload: error,
  };
}
export function fetchSmallProductInfo(ProductNum) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SMALL_PRODUCT_INFO });
    axios.get(
      `${PRODUCTS_URL}search/?ProductNum=${ProductNum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSmallProductInfoSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSmallProductInfoFailure(err));
        }
      });
  };
}

export function clearSmallProdStatus() {
  return {
    type: CLEAR_SMALL_PRODUCT,
  };
}

export function fetchCRVValuesSuccess(values) {
  return {
    type: FETCH_CRV_VALUES_SUCCESS,
    payload: values,
  };
}
export function fetchCRVValuesFailure(error) {
  return {
    type: FETCH_CRV_VALUES_FAILURE,
    payload: error,
  };
}
export function fetchCRVValues() {
  return (dispatch) => {
    dispatch({ type: REQUEST_CRV_VALUES });
    axios.get(
      `${PRODUCTS_URL}crv/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchCRVValuesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchCRVValuesFailure(err));
        }
      });
  };
}

function fetchDefaultBuyersSuccess(data) {
  return {
    type: REQUEST_DEFAULT_BUYERS_SUCCESS,
    payload: data,
  };
}

function fetchDefaultBuyersError(error) {
  return {
    type: REQUEST_DEFAULT_BUYERS_FAILURE,
    payload: error,
  };
}

export function fetchDefaultBuyers() {
  return (dispatch, getState) => {
    const state = getState();
    const company_id = state.header.selectedCompany.value
    let params = {};
    if(!isGGI) {
      params.company_id = company_id;
    }
    dispatch({ type: REQUEST_DEFAULT_BUYERS });
    axios({
      method: 'get',
      url: `${BASE_USER_URL}users/`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      params,
    })
      .then(
        (response) => {
          dispatch(fetchDefaultBuyersSuccess(response));
        },
        (err) => {
          if (err.status === 500 || err.status === 404) {
            err.data = DEFAULT_ERROR;
          }
          if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
            document.getElementById('tokenInvalid').style.display = 'flex'
          } else {
            dispatch(fetchDefaultBuyersError(err));
          }
        },
      );
  };
}

export function attachProductImageSuccess() {
  return {
    type: ATTACH_PRODUCT_IMAGE_SUCCESS,
  };
}
export function attachProductImageFailure(error) {
  return {
    type: ATTACH_PRODUCT_IMAGE_FAILURE,
    payload: error,
  };
}
export function attachProductImage(Product_id, img) {
  return (dispatch) => {
    dispatch({ type: ATTACH_PRODUCT_IMAGE });
    const data = new FormData();
    data.append('Thumbnail', img);
    return axios.post(
      `${PRODUCTS_URL}image/${Product_id}`, data,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      },
    )
      .then(() => {
        dispatch(attachProductImageSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(attachProductImageFailure(err));
        }
      });
  };
}

export function clearAttachedProductImage() {
  return {
    type: CLEAR_ATTACHED_PRODUCT_IMAGE,
  };
}

export function saveCategory2Products(products, category2Id, handleSuccess, handleFailure) {
  return axios({
    method: 'put',
    url: `${PRODUCTS_URL}category2/${category2Id}/product`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: {
      product_ids: products,
    },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err.data);
      }
    });
}

export function saveCategory2ProductsB2B(products, category2Id, handleSuccess, handleFailure) {
  return axios({
    method: 'put',
    url: `${PRODUCTS_URL}category2_b2b/${category2Id}/product`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: {
      product_ids: products,
    },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err.data);
      }
    });
}

export function setCurrentProduct(Product_id) {
  return {
    type: SET_CURRENT_PRODUCT,
    payload: Product_id,
  };
}

function fetchRelatedProductsSuccess(data) {
  return {
    type: FETCH_RELATED_PRODUCTS_SUCCESS,
    payload: data,
  };
}
function fetchRelatedProductsFailure(error) {
  return {
    type: FETCH_RELATED_PRODUCTS_FAILURE,
    payload: error,
  };
}
export function fetchRelatedProducts(ProductNum) {
  return (dispatch) => {
    dispatch({ type: FETCH_RELATED_PRODUCTS });
    axios.get(
      `${INVENTORY_CONVERTS_URL}products/${ProductNum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchRelatedProductsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchRelatedProductsFailure(err));
        }
      });
  };
}

function fetchSuggestedProdNumSuccess(data) {
  return {
    type: FETCH_SUGGESTED_PROD_NUM_SUCCESS,
    payload: data,
  };
}
function fetchSuggestedProdNumFailure(error) {
  return {
    type: FETCH_SUGGESTED_PROD_NUM_FAILURE,
    payload: error,
  };
}
export function fetchSuggestedProdNum(ProductCategory_id) {
  return (dispatch) => {
    dispatch({ type: FETCH_SUGGESTED_PROD_NUM });
    axios.get(
      `${PRODUCTS_URL}suggestednum/${ProductCategory_id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSuggestedProdNumSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSuggestedProdNumFailure(err));
        }
      });
  };
}

function fetchSuggestDigitSuccess(data) {
  return {
    type: FETCH_SUGGEST_DIGIT_SUCCESS,
    payload: data,
  };
}
function fetchSuggestDigitFailure(error) {
  return {
    type: FETCH_SUGGEST_DIGIT_FAILURE,
    payload: error,
  };
}
export function fetchSuggestDigit(prodNum) {
  return (dispatch) => {
    dispatch({ type: FETCH_SUGGEST_DIGIT });
    axios.get(
      `${PRODUCTS_URL}suggest/${prodNum}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchSuggestDigitSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchSuggestDigitFailure(err));
        }
      });
  };
}

export function clearSuggestDigit() {
  return {
    type: CLEAR_SUGGEST_DIGIT,
  };
}

function fetchPackageTypesSuccess(data) {
  return {
    type: FETCH_PACKAGE_TYPES_SUCCESS,
    payload: data,
  };
}
function fetchPackageTypesFailure(error) {
  return {
    type: FETCH_PACKAGE_TYPES_FAILURE,
    data: error,
  };
}
export function fetchPackageTypes() {
  return (dispatch) => {
    dispatch({ type: FETCH_PACKAGE_TYPES });
    axios.get(
      `${PRODUCTS_URL}packagetype/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchPackageTypesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchPackageTypesFailure(err));
        }
      });
  };
}

function editPackageTypeSuccess(data) {
  return {
    type: EDIT_PACKAGE_TYPE_SUCCESS,
    payload: data,
  };
}
function editPackageTypeFailure(error) {
  return {
    type: EDIT_PACKAGE_TYPE_FAILURE,
    payload: error,
  };
}
export function editPackageType(packageTypes) {
  return (dispatch) => {
    dispatch({ type: EDIT_PACKAGE_TYPE });
    axios.post(
      `${PRODUCTS_URL}packagetype/`, packageTypes,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editPackageTypeSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editPackageTypeFailure(err));
        }
      });
  };
}

export function clearPackageTypeEdited() {
  return {
    type: CLEAR_PACKAGE_TYPE_EDITED,
  };
}

export function deletePackageTypeSuccess() {
  return {
    type: DELETE_PACKAGE_TYPE_SUCCESS,
  };
}
export function deletePackageTypeFailure(error) {
  return {
    type: DELETE_PACKAGE_TYPE_FAILURE,
    payload: error,
  };
}
export function deletePackageType(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_PACKAGE_TYPE });
    axios.delete(
      `${PRODUCTS_URL}packagetype/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(fetchPackageTypes());
        dispatch(deletePackageTypeSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deletePackageTypeFailure(err));
        }
      });
  };
}

function fetchMeasurementUnitSuccess(data) {
  return {
    type: FETCH_MEASUREMENT_UNIT_SUCCESS,
    payload: data,
  };
}
function fetchMeasurementUnitFailure(error) {
  return {
    type: FETCH_MEASUREMENT_UNIT_FAILURE,
    data: error,
  };
}
export function fetchMeasurementUnit() {
  return (dispatch) => {
    dispatch({ type: FETCH_MEASUREMENT_UNIT });
    axios.get(
      `${PRODUCTS_URL}measureunit/`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchMeasurementUnitSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchMeasurementUnitFailure(err));
        }
      });
  };
}

function editMeasurementUnitSuccess(data) {
  return {
    type: EDIT_MEASUREMENT_UNIT_SUCCESS,
    payload: data,
  };
}
function editMeasurementUnitFailure(error) {
  return {
    type: EDIT_MEASUREMENT_UNIT_FAILURE,
    data: error,
  };
}
export function editMeasurementUnit(measurementUnit) {
  return (dispatch) => {
    dispatch({ type: EDIT_MEASUREMENT_UNIT });
    axios.post(
      `${PRODUCTS_URL}measureunit/`, measurementUnit,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editMeasurementUnitSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editMeasurementUnitFailure(err));
        }
      });
  };
}

export function clearMeasurementUnitEdited() {
  return {
    type: CLEAR_MEASUREMENT_UNIT_EDITED,
  };
}

export function deleteMeasurementUnitSuccess() {
  return {
    type: DELETE_MEASUREMENT_UNIT_SUCCESS,
  };
}
export function deleteMeasurementUnitFailure(error) {
  return {
    type: DELETE_MEASUREMENT_UNIT_FAILURE,
    payload: error,
  };
}
export function deleteMeasurementUnit(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_DELETE_MEASUREMENT_UNIT });
    axios.delete(
      `${PRODUCTS_URL}measureunit/${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then(() => {
        dispatch(fetchMeasurementUnit());
        dispatch(deleteMeasurementUnitSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteMeasurementUnitFailure(err));
        }
      });
  };
}

function fetchConvertableProductsSuccess(data) {
  return {
    type: FETCH_CONVERTABLE_PRODUCTS_SUCCESS,
    payload: data,
  };
}
function fetchConvertableProductsFailure(error) {
  return {
    type: FETCH_CONVERTABLE_PRODUCTS_FAILURE,
    data: error,
  };
}
export function fetchConvertableProducts(pn, type) {
  let createParam;
  if (type === 'create') {
    createParam = true;
  }
  return (dispatch) => {
    dispatch({ type: FETCH_CONVERTABLE_PRODUCTS });
    axios.get(
      `${PRODUCTS_URL}convertable/${pn}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        params: {
          create: createParam,
        },
      },
    )
      .then((response) => {
        dispatch(fetchConvertableProductsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchConvertableProductsFailure(err));
        }
      });
  };
}
export function fetchProductPartsList(pn, type) {
  let createParam;
  if (type === 'create') {
      createParam = true;
    }
  return (dispatch) => {
      dispatch({ type: FETCH_PRODUCT_PARTS_LIST });
      axios.get(
          `${PRODUCTS_URL}convertable2/${pn}`,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          params: {
              create: createParam,
              },
        },
      )
        .then((response) => {
            dispatch(fetchProductPartsListSuccess(response));
          }, (err) => {
            if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchProductPartsListFailure(err));
              }
          });
    };
  }

function fetchProductPartsListSuccess(data) {
  return {
      type: FETCH_PRODUCT_PARTS_LIST_SUCCESS,
      payload: data,
    };
}

function fetchProductPartsListFailure(error) {
  return {
      type: FETCH_PRODUCT_PARTS_LIST_FAILURE,
      data: error,
    };
}

export function attachDocumentSuccess() {
  return {
    type: ATTACH_DOCUMENT_SUCCESS,
  };
}
export function attachDocumentFailure(error) {
  return {
    type: ATTACH_DOCUMENT_FAILURE,
    payload: error,
  };
}
export function attachDocument(files) {
  return (dispatch) => {
    dispatch({ type: ATTACH_DOCUMENT });
    const data = new FormData();
    data.append('file', files[0]);
    return axios.post(
      `${UPLOAD_URL}document/`, data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(attachDocumentSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(attachDocumentFailure(err));
        }
      });
  };
}

export function importProducts(file, callBack = () =>{}) {
  return (dispatch) => {
    const data = new FormData();
    data.append('file', file);
    return axios.post(
      `${PRODUCTS_IMPORT_URL}`, data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        alert('Import Success');
        callBack();
      }).catch(err=>{
        if(err && err.data) {
          alert(err.data);
        } else {
          alert('Import failed');
        }
        callBack();
      });
  };
}

function continueOrDiscontinueProductSuccess() {
  return {
    type: CONTINUE_OR_DISCONTINUE_PRODUCT_SUCCESS,
  };
}

function continueOrDiscontinueProductError(error) {
  return {
    type: CONTINUE_OR_DISCONTINUE_PRODUCT_FAILURE,
    payload: error,
  };
}

export function continueProduct(productId) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const selectedWarehouse = state.header.selectedWarehouse;
    let url =  `${PRODUCTS_URL}${productId}/continue?Company_id=${selectedCompany.value}&warehouse_id=${selectedWarehouse.value}`
    dispatch({
      type: REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT,
    });
    return axios({
      method: 'PUT',
      url,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(() => {
        dispatch(continueOrDiscontinueProductSuccess());
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(continueOrDiscontinueProductError(err));
        }
      });
  };
}

export function discontinueProduct(productId) {
  return (dispatch, getState) => {
    const state = getState();
    const selectedCompany = state.header.selectedCompany;
    const selectedWarehouse = state.header.selectedWarehouse;
    let url =  `${PRODUCTS_URL}${productId}/discontinue?Company_id=${selectedCompany.value}&warehouse_id=${selectedWarehouse.value}`
    dispatch({
      type: REQUEST_CONTINUE_OR_DISCONTINUE_PRODUCT,
    });
    return axios({
      method: 'PUT',
      url,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(() => {
        dispatch(continueOrDiscontinueProductSuccess());
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(continueOrDiscontinueProductError(err));
        }
      });
  };
}

function deleteProductSuccess() {
  return {
    type: DELETE_PRODUCT_SUCCESS,
  };
}
function deleteProductError(error) {
  return {
    type: DELETE_PRODUCT_FAILURE,
    payload: error,
  };
}
export function deleteProduct(productId) {
  return (dispatch) => {
    dispatch({
      type: DELETE_PRODUCT,
    });
    return axios({
      method: 'DELETE',
      url: `${PRODUCTS_URL}${productId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then(() => {
        dispatch(deleteProductSuccess());
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(deleteProductError(err));
        }
      });
  };
}

export function updateProductGroupSuccess() {
  return {
    type: UPDATE_PRODUCT_SUCCEESS,
  };
}
export function updateProductGroupFailure(error) {
  return {
    type: UPDATE_PRODUCT_FAILURE,
    payload: error,
  };
}
export function updateProductGroup(productId, newProductNum, cb = () => {}) {
  return (dispatch) => {
    dispatch({ type: REQUEST_UPDATE_PRODUCT });
    const token = localStorage.getItem('token');
    return axios({
      method: 'post',
      url: `${PRODUCTS_URL}new_product_num/${productId}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        ProductNum: newProductNum,
      },
    })
      .then(() => {
        cb()
        dispatch(updateProductGroupSuccess());
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(updateProductGroupFailure(err));
        }
      });
  };
}

export function saveMobileDescriptionBoxTextSuccess(response) {
  return {
    type: SAVE_MOBILE_DESCRIPTION_BOX_TEXT_SUCCESS,
    payload: response,
  };
}
export function saveMobileDescriptionBoxTextFailure(error) {
  return {
    type: SAVE_MOBILE_DESCRIPTION_BOX_TEXT_FAILURE,
    payload: error,
  };
}

/**
  * Api call to save mobile description box text
  *
  * @param {Number} productId
  * @param {String} mobileDescBoxText string of html
  */
export function saveMobileDescriptionBoxText(productId, mobileDescBoxText) {
  return (dispatch) => {
    dispatch({ type: REQUEST_SAVE_MOBILE_DESCRIPTION_BOX_TEXT });
    const token = localStorage.getItem('token');
    return axios({
      method: 'put',
      url: `${PRODUCTS_URL}${productId}/rich-text`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        rich_text_description: mobileDescBoxText,
      },
    })
      .then((response) => {
        dispatch(saveMobileDescriptionBoxTextSuccess(response));
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(saveMobileDescriptionBoxTextFailure(err));
        }
      });
  };
}

/**
  * Gets the previously saved description text
  *
  * @param {Number} productId
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export function fetchMobileDescriptionBoxText(productId, handleSuccess, handleFailure) {
  const token = localStorage.getItem('token');
  return axios({
    method: 'get',
    url: `${PRODUCTS_URL}${productId}/rich-text`,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        handleFailure(err.data);
      }
    });
}

/**
  * Updates product images
  *
  * @param {Number} productId
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const updateProductImages = (productId, images, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'put',
    url: `${PRODUCTS_URL}${productId}/image`,
    data: {
      Images: images,
    },
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      // err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      handleFailure(err.data);
    }
  });
};

/**
  * Gets previously set product images
  *
  * @param {Number} productId
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const getProductImages = (productId, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'get',
    url: `${PRODUCTS_URL}${productId}/image`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      handleFailure(err.data);
    }
  });
};

/**
  * Delete previously saved image
  *
  * @param {Number} imageId
  * @param {func} handleSuccess
  * @param {func} handleFailure
  */
export const deleteProductImages = (imageId, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'delete',
    url: `${PRODUCTS_URL}image/${imageId}`,
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      handleFailure(err.data);
    }
  });
};

export const saveCalculationType = (type, handleSuccess, handleFailure) => {
  const token = localStorage.getItem('token');
  const config = {
    method: 'post',
    url: '',
  };
  axios({
    ...config,
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    handleSuccess(response.data);
  }, (err) => {
    if (err.status === 500 || err.status === 404) {
      err.data = DEFAULT_ERROR;
    }
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      handleFailure(err.data);
    }
  });
};

// Get Display Categories
export function requestDisplayCategories() {
  return {
    type: REQUEST_DISPLAY_CATEGORIES,
  };
}
export function fetchDisplayCategoriesSuccess(displayCategories) {
  displayCategories = displayCategories.data;
  return {
    type: FETCH_DISPLAY_CATEGORIES_SUCCESS,
    payload: displayCategories,
  };
}
export function fetchDisplayCategoriesFailure(error) {
  return {
    type: FETCH_DISPLAY_CATEGORIES_FAILURE,
    payload: error,
  };
}
export function fetchDisplayCategories(product_id) {
  return (dispatch) => {
    dispatch(requestDisplayCategories());
    return axios.get(
      DISPLAY_CATEGORIES_URL + product_id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(fetchDisplayCategoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchDisplayCategoriesFailure(err));
        }
      });
  };
}

// Post Display Categories
export function requestEditDisplayCategories() {
  return {
    type: REQUEST_EDIT_DISPLAY_CATEGORIES,
  };
}
export function editDisplayCategoriesSuccess(response) {
  return {
    type: EDIT_DISPLAY_CATEGORIES_SUCCESS,
    payload: response,
  };
}
export function editDisplayCategoriesFailure(error) {
  return {
    type: EDIT_DISPLAY_CATEGORIES_FAILURE,
    payload: error,
  };
}
export function editDisplayCategories(productId, outputCategories) {
  return (dispatch) => {
    dispatch(requestEditDisplayCategories());
    axios.put(
      `${DISPLAY_CATEGORIES_URL}${productId}`,
      outputCategories,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        dispatch(editDisplayCategoriesSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(editDisplayCategoriesFailure(err));
        }
      });
  };
}

// Products Quick Access
export function fetchQuickAccess(ProductNum, handleSuccess, handleFailure) {
  return axios({
    method: 'get',
    url: `${PRODUCTS_URL}search/?ProductNum=${ProductNum}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then((response) => {
      handleSuccess(response);
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        alert("Server Error, please refresh. If problem persists, contact Administrator.");
      }
      if (err.status === 400) {
        handleFailure(err);
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      }
    });
}

export function requestInitializeESL() {
  return {
    type: REQUEST_INITIALIZE_ESL,
  };
}
export function initializeESL(productId) {
  return (dispatch) => {
    dispatch(requestInitializeESL());
    return axios({
          method: 'put',
          url: `${ESL_INITIALIZE}${productId}`,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
  };
}

export function requestDeleteESL() {
  return {
    type: REQUEST_DELETE_ESL,
  };
}
export function deleteESL(productId) {
  return (dispatch) => {
    dispatch(requestInitializeESL());
    return axios({
          method: 'delete',
          url: `${ESL_DELETE}${productId}`,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
  };
}

export function requestFetchESLTemplate() {
  return {
    type: REQUEST_FETCH_ESL_TEMPLATE,
  };
}
export function fetchESLTemplate() {
  return (dispatch) => {
    dispatch(requestFetchESLTemplate());
    return axios({
          method: 'get',
          url: `${ESL_GET_TEMPLATE}`,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
  };
}

export function requestFetchESL() {
  return {
    type: REQUEST_FETCH_ESL,
  };
}
export function fetchESL(productId) {
  return (dispatch) => {
    dispatch(requestFetchESL());
    return axios({
          method: 'get',
          url: `${ESL_SAVE}`,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
  };
}

export function requestSaveESL() {
  return {
    type: REQUEST_SAVE_ESL,
  };
}
export function saveESL(productId, ESLCode, TemplateId, TemplateName) {
  return (dispatch) => {
    dispatch(requestSaveESL());
    return axios({
          method: 'post',
          url: `${ESL_SAVE}`,
          data: {
            ProductId: productId,
            ESLCode: ESLCode,
            TemplateId: TemplateId,
            TemplateName: TemplateName,
          },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
  };
}

export const productUpload = (file, success) => {
  axios({
    method: 'POST',
    data: file,
    url: `${ROOT_URL}v2/product/import-product`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert('error uploading product.');
    }
  });
}

// smiling home
export const productUpload2 = (file, success, failed) => {
  axios({
    method: 'POST',
    data: file,
    url: `${ROOT_URL}v2/product/import`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
      document.getElementById('tokenInvalid').style.display = 'flex'
    } else {
      alert('error uploading product.');
      failed();
    }
  });
}

export const productUploadGFD = (file, success, failed) => {
  axios({
    method: 'POST',
    data: file,
    url: `${ROOT_URL}v1/product/upload-product `,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  }).then((response) => {
    success();
  }, (err) => {
    let errmsg = '?';
    if (err.data) {
      errmsg = JSON.stringify(err.data);
    } else {
      errmsg = JSON.stringify(err);
    }
    alert(`error uploading product. ${errmsg}`);
    failed();
  });
}

export const priceLevelUpload = (data, success, failed, company, warehouse) => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/product/pricelevel_import?company_id=${company.value}&warehouse_id=${warehouse.value}`,
    data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      // 'Content-Type': 'multipart/form-data'
    }
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed(err);
      }
    })
}

export function verifyBarcode({
  AutoPO,
  default_po_quantity,
  LimitQuantityPerOrder,
  MixedProductBaseUnit,
  MixedProduct,
  Bin,
  BinRangeList,
  ConvertNum,
  ConvertType,
  Notes,
  ProdCreateDate,
  MinOrderQty,
  ClassNo,
  CatalogPage,
  BaseCost,
  CustomDutyPercent,
  HtmsNum,
  // CaseCost,
  PromoTier1Qty,
  PromoTier2Qty,
  Units_Case,
  Units_InnerBox,
  CRV,
  CRV_id,
  FOBCost,
  Default_Warehouse_id,
  Default_WarehouseFromBin_id,
  Default_WarehouseToBin_id,
  Default_WarehouseZone_id,
  Description,
  Description2,
  Description3,
  Height,
  HMartCode,
  InStockPrice,
  InternalBarcode,
  IsB2B,
  IsB2C,
  IsDiscontinued,
  IsLarge,
  IsOverSaleable,
  IsPromotion,
  IsRelated,
  IsStopSale,
  GeneralNum,
  IsTaxable,
  IsAllTaxable,
  IsNonFood,
  IsWholesaleOnly,
  IsMobile,
  IsSoldNationwide,
  IsSyncNuOrder,
  IsSyncShopify,
  IsRetailPack,
  IsCombo,
  IsNewArrival,
  IsGreatDeal,
  PurchaseConvertUnit,
  IsProposition65,
  IsSyncToScales,
  IsSyncToESL,
  IsAFGChioce,
  IsAlcohol,
  Length,
  Level,
  LowestSalePrice,
  MaxStockRange,
  MaxWeightRange,
  MeasureUnit,
  MeasureUnit_2,
  DimensionUnit,
  DimensionHeight,
  DimensionLength,
  DimensionWidth,
  CartonWidth,
  CartonHeight,
  CartonLength,
  CartonWeight,
  CaseHeight,
  CaseLength,
  CaseWidth,
  PalletHeight,
  PalletLength,
  PalletWidth,
  UnitCBF,
  UnitCBM,
  CaseCBF,
  CaseCBM,
  PalletCBF,
  PalletCBM,
  CasePerPallet,
  Volume,
  MinStockRange,
  MinWeightRange,
  Name,
  NetCost,
  NetWeight,
  CaseWt,
  BoxWt,
  PackageSize,
  PackageSize_1,
  PackageSize_2,
  CalcoDispatchCase,
  CalcoDispatchBag,
  PackageType,
  PackageType_2,
  PriceType,
  Product_id,
  ProductBarcode,
  ProductCategory1_id,
  ProductCategory2_id,
  ProductCost,
  ProductGroup_id,
  ProductNum,
  ProductType,
  Tare,
  DateFlag,
  Purchaser_User_id,
  IsStopPurchase,
  Sales_User_id,
  RefNum,
  RefPrice,
  Related_Product_id,
  RoundPriceLevels,
  ShiftLife,
  BufferTime,
  ShippingWeight,
  UnitPerPallet,
  VendorProdNo,
  Vendors,
  Width,
  Zone,
  ViewableLanguages,
  ShippingFeeUnitPrice,
  TaxAmount,
  Temperature,
  MiscUnitPrice,
  Brand,
  SubjectCategory,
  TopFlag,
  Zone2,
  Bin2,
  Level2,
  Zone3,
  Bin3,
  Level3,
  TJXStyleNum,
  UPC,
  GTIN,
  Color,
  Size,
  English_Details_Brand,
  Chinese_Details_Brand,
  English_Brand_Origin,
  Chinese_Brand_Origin,
  English_Details_NetContent,
  Chinese_Details_NetContent,
  English_Details_Made_In,
  Chinese_Details_Made_In,
  English_Details_Organic,
  Chinese_Details_Organic,
  English_Details_Contains_Sugar,
  Chinese_Details_Contains_Sugar,
  English_Details_Flavor,
  Chinese_Details_Flavor,
  English_Details_Ingredients,
  Chinese_Details_Ingredients,
  PackageSize_3,
  MeasureUnit_3,
  PalletSize,
  MadeIn,
  FW,
  CustomerStr,
  Channel,
  ActualNW,
  InventoryIsMobile,
  // isSH
  ItemName,
  ColorCode,
  QBItemNum,
  RootDescription,
  PackingSizeCode,
  RootItemName,
  RootItemNum,
  OldPrintNum,
  ShortColorCode,
  BackColor,
  DesignPrintNum,
  ShortName,
  BoxPacking,
  AmazonItemNum,
  AmazonBoxPacking,
  AmazonSKU,
  AmazonPrice,
  FrontPOColor,
  BackPOColor,
}, {
  priceLv1,
  priceLv2,
  priceLv3,
  priceLv4,
  priceLv5,
  p1Percentage,
  p2Percentage,
  p3Percentage,
  p4Percentage,
  p5Percentage,
  relatedProducts,
  productParts,
  ProductSKU,
  meta_info,
  selectedCompany,
  selectedWarehouse,
}, handleResult) {
  if (MadeIn) MadeIn = MadeIn.value || MadeIn;
  if (FW) FW = FW.value || FW;
  if (CustomerStr) CustomerStr = CustomerStr.value || CustomerStr;
  if (GTIN) GTIN = GTIN.value || GTIN;
  if (Channel) Channel = Channel.value || Channel;

  let ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost);
  let CustomDutyCost = (Number(CustomDutyPercent ? CustomDutyPercent : 0)/100) * Number(BaseCost);
  if (isSV) {
    ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost) + CustomDutyCost;
  }
  if(isHMM) {
    ArrivalPrice = Number(MiscUnitPrice) + Number(ShippingFeeUnitPrice) + Number(ProductCost) + Number(TaxAmount);
  }
  const newVendors = [];
  if (Vendors) {
    Vendors.map((vendor) => {
      if (vendor.Vendor_id) {
        vendor.Vendor_id = vendor.Vendor_id.value || vendor.Vendor_id;
      }
      newVendors.push(vendor);
    });
  }
  if (Related_Product_id) Related_Product_id = Related_Product_id.value || Related_Product_id;
  if (ProductGroup_id) ProductGroup_id = ProductGroup_id.value || ProductGroup_id;
  if (ProductCategory1_id) ProductCategory1_id = ProductCategory1_id.value || ProductCategory1_id;
  if (ProductCategory2_id) ProductCategory2_id = ProductCategory2_id.value || ProductCategory2_id;
  if (PackageType) PackageType = PackageType.value || PackageType;
  if (ProductType) ProductType = ProductType.value || ProductType;
  if (DateFlag) DateFlag = DateFlag.value || DateFlag;
  if (Default_Warehouse_id) Default_Warehouse_id = Default_Warehouse_id.value || Default_Warehouse_id;
  if (Default_WarehouseZone_id) Default_WarehouseZone_id = Default_WarehouseZone_id.value || Default_WarehouseZone_id;
  if (!IsDiscontinued) IsDiscontinued = 'false';
  if (!IsTaxable) IsTaxable = 'false';
  if (!IsAllTaxable) IsAllTaxable = 'false';
  if (!IsNonFood) IsNonFood = 'false';
  if (!IsOverSaleable) IsOverSaleable = 'false';
  if (!IsPromotion) IsPromotion = 'false';
  if (!IsWholesaleOnly) IsWholesaleOnly = 'false';
  if (PackageType_2) PackageType_2 = PackageType_2.value || PackageType_2;
  if (MeasureUnit_2) MeasureUnit_2 = MeasureUnit_2.value || MeasureUnit_2;
  if (MeasureUnit) { MeasureUnit = MeasureUnit.value || MeasureUnit; }


  const mixedProduct = [];
  if (MixedProduct) {
    for (var i = 0; i < MixedProduct.length; i++) {
      let temp = {};
      if (MixedProductBaseUnit.value) {
        temp.Unit = MixedProductBaseUnit.value;
      } else {
        temp.Unit = MixedProductBaseUnit;
      }
      if(MixedProduct[i].MixedUnit.value) {
        temp.MixedUnit = MixedProduct[i].MixedUnit.value;
      } else {
        temp.MixedUnit = MixedProduct[i].MixedUnit;
      }
      temp.ProductName = MixedProduct[i].ProductName;
      temp.ProductNum = MixedProduct[i].ProductNum;
      temp.ProductSKU = MixedProduct[i].ProductSKU;
      temp.Quantity = MixedProduct[i].Quantity;
      mixedProduct[i] = temp;
    }
  }

  if ( !isNumeric(LimitQuantityPerOrder) ) {
    if ( LimitQuantityPerOrder === null || LimitQuantityPerOrder === "" || !LimitQuantityPerOrder ) {
      LimitQuantityPerOrder = 0;
    } else {
      alert("Limited Qty/Order must be a number!");
      return (dispatch) => {
        dispatch({ type: EDIT_PRODUCT_FAILURE });
      }
    }
  }
  if (LimitQuantityPerOrder < 0) {
    LimitQuantityPerOrder = 0;
  }

  let binRangeList = [];
  if (BinRangeList) {
    binRangeList = BinRangeList.slice();
    BinRangeList.map((bin, index) => {
      if ((typeof bin.DefaultBin === 'object') && bin.DefaultBin.value) {
        binRangeList[index].DefaultBin = bin.DefaultBin.value;
      } else {
        binRangeList[index].DefaultBin = bin.DefaultBin;
      }
      if ((typeof bin.Default_Level === 'object') && bin.Default_Level.value) {
        binRangeList[index].Default_Level = bin.Default_Level.value;
      } else {
        binRangeList[index].Default_Level = bin.Default_Level;
      }
    });
  }
  if (DimensionUnit && DimensionUnit.value) {
    DimensionUnit = DimensionUnit.value;
  }
  return (dispatch) => {
    dispatch({ type: REQUEST_EDITING_PRODUCT });
    axios.put(
      (`${ROOT_URL}v1/product/check_barcode_isexist`),
      {
        AutoPO,
        default_po_quantity,
        meta_title: meta_info.meta_title,
        meta_keywords: meta_info.meta_keywords,
        meta_description: meta_info.meta_description,
        LimitQuantityPerOrder,
        MixedProduct: mixedProduct,
        Bin,
        BinRangeList: binRangeList,
        ConvertNum,
        ConvertType,
        CRV,
        CRV_id: (CRV_id && CRV_id.value) || CRV_id,
        FOBCost,
        Notes,
        ProdCreateDate,
        MinOrderQty,
        ClassNo,
        CatalogPage,
        BaseCost,
        CustomDutyPercent,
        HtmsNum,
        // CaseCost,
        PromoTier1Qty,
        PromoTier2Qty,
        Units_Case,
        Units_InnerBox,
        Default_Warehouse_id,
        Default_WarehouseFromBin_id,
        Default_WarehouseToBin_id,
        Default_WarehouseZone_id,
        Description,
        Description2,
        Description3,
        Height,
        HMartCode,
        InStockPrice,
        InternalBarcode,
        IsDiscontinued,
        IsB2B,
        IsB2C,
        IsLarge,
        IsOverSaleable,
        IsPromotion,
        IsRelated,
        IsStopSale,
        GeneralNum,
        IsTaxable,
        IsAllTaxable,
        IsNonFood,
        IsWholesaleOnly,
        IsMobile,
        IsSoldNationwide,
        IsSyncNuOrder,
        IsSyncShopify,
        IsRetailPack,
        IsCombo,
        IsNewArrival,
        IsGreatDeal,
        PurchaseConvertUnit,
        IsProposition65,
        IsSyncToScales,
        IsSyncToESL,
        IsAFGChioce,
        IsAlcohol,
        Length,
        Level,
        LowestSalePrice,
        MaxStockRange,
        MaxWeightRange,
        MeasureUnit,
        MeasureUnit_2,
        DimensionUnit,
        DimensionHeight,
        DimensionLength,
        DimensionWidth,
        CartonWidth,
        CartonHeight,
        CartonLength,
        CartonWeight,
        CaseHeight,
        CaseLength,
        CaseWidth,
        PalletHeight,
        PalletLength,
        PalletWidth,
        UnitCBF,
        UnitCBM,
        CaseCBF,
        CaseCBM,
        PalletCBF,
        PalletCBM,
        CasePerPallet,
        Volume,
        MinStockRange,
        MinWeightRange,
        Name,
        NetCost,
        NetWeight,
        CaseWt,
        BoxWt,
        P1Percentage: p1Percentage,
        P2Percentage: p2Percentage,
        P3Percentage: p3Percentage,
        P4Percentage: p4Percentage,
        P5Percentage: p5Percentage,
        PackageSize,
        PackageSize_1,
        PackageSize_2,
        CalcoDispatchCase,
        CalcoDispatchBag,
        PackageType,
        PackageType_2,
        PriceLv1: priceLv1,
        PriceLv2: priceLv2,
        PriceLv3: priceLv3,
        PriceLv4: priceLv4,
        PriceLv5: priceLv5,
        PriceType,
        ProductBarcode,
        ProductCategory1_id,
        ProductCategory2_id,
        ProductCost,
        ProductGroup_id,
        ProductNum,
        ProductType,
        Tare,
        DateFlag,
        Purchaser_User_id: (Purchaser_User_id && Purchaser_User_id.value) || Purchaser_User_id,
        IsStopPurchase,
        Sales_User_id: (Sales_User_id && Sales_User_id.value) || Sales_User_id,
        RefNum,
        RefPrice,
        Related_Product_id,
        relations: relatedProducts,
        relations2: productParts.rows,
        RoundPriceLevels,
        ShiftLife,
        BufferTime,
        ShippingWeight,
        UnitPerPallet,
        VendorProdNo,
        Vendors: newVendors,
        Width,
        Zone,
        ViewableLanguages,
        ProductSKU,
        ShippingFeeUnitPrice,
        TaxAmount,
        Temperature,
        MiscUnitPrice,
        ArrivalPrice,
        CustomDutyCost,
        Brand,
        SubjectCategory,
        TopFlag,
        Zone2,
        Bin2,
        Level2,
        Zone3,
        Bin3,
        Level3,
        TJXStyleNum,
        UPC,
        GTIN,
        Color,
        Size,
        English_Details_Brand,
        Chinese_Details_Brand,
        English_Brand_Origin,
        Chinese_Brand_Origin,
        English_Details_NetContent,
        Chinese_Details_NetContent,
        English_Details_Made_In,
        Chinese_Details_Made_In,
        English_Details_Organic,
        Chinese_Details_Organic,
        English_Details_Contains_Sugar,
        Chinese_Details_Contains_Sugar,
        English_Details_Flavor,
        Chinese_Details_Flavor,
        English_Details_Ingredients,
        Chinese_Details_Ingredients,
        PackageSize_3: PackageSize_3 || '',
        MeasureUnit_3: MeasureUnit_3 ? (MeasureUnit_3.value || MeasureUnit_3) : '',
        PalletSize,
        MadeIn,
        FW,
        CustomerStr,
        Channel,
        ActualNW,
        InventoryIsMobile,
        // isSH
        ItemName,
        ColorCode,
        QBItemNum,
        RootDescription,
        PackingSizeCode,
        RootItemName,
        RootItemNum,
        OldPrintNum,
        ShortColorCode,
        BackColor,
        DesignPrintNum,
        ShortName,
        BoxPacking,
        AmazonItemNum,
        AmazonBoxPacking,
        AmazonSKU,
        AmazonPrice,
        FrontPOColor,
        BackPOColor,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((response) => {
        handleResult(true);
      }, (err) => {
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          handleResult(false, JSON.stringify(err.data));
        }
      });
  };
}

export const fetchGlAccountRecords = () => {
  return axios.get(GENERAL_LEDGER_URL, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
}

export const fetchBarcodePdf = (prdId) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v2/product/label/${prdId}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    responseType: 'blob',
  }).then((res) =>{
    var a = document.createElement('a');
      a.target = '_blank'
      a.href =URL.createObjectURL(res.data);
      document.body.appendChild(a); 
      a.click(); 
      document.body.removeChild(a); 
  }).catch((err)=> {
    alert(JSON.stringify(err.response.data))
  });
}



// WEBPACK FOOTER //
// ./master/jsx/actions/products_actions.js